
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3ePvn", function(module, exports) {
var $61d8c334831b33b2$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $61d8c334831b33b2$export$45e63649edff1e2a = 'ASSETS';
const $61d8c334831b33b2$export$45c80c6b98d65f36 = 3;
const $61d8c334831b33b2$export$7b4183e5f0de390a = 1000;
const $61d8c334831b33b2$export$2edbfcb69dc77e78 = 1;
const $61d8c334831b33b2$export$891dc7068a3d5e65 = 14;
const $61d8c334831b33b2$export$6e594fe130dbe3b = 14;
var $61d8c334831b33b2$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $61d8c334831b33b2$export$c889532d47d74e9c = 'bff';
const $61d8c334831b33b2$export$123b1b8742c0ac6a = 'flightdeck';
const $61d8c334831b33b2$export$1631e8a201b50246 = 'uc-menu-items';
module.exports["BFFConsumerEnum"] = $61d8c334831b33b2$export$9a146e025690327e;
module.exports["ASSETS_APP_KEY"] = $61d8c334831b33b2$export$45e63649edff1e2a;
module.exports["RETRY_INTERVAL_DEFAULT"] = $61d8c334831b33b2$export$7b4183e5f0de390a;
module.exports["MAX_ATTEMPTS_NEW_DEFAULT"] = $61d8c334831b33b2$export$2edbfcb69dc77e78;
module.exports["RequestStatus"] = $61d8c334831b33b2$export$600e7c1f9e0414e1;
module.exports["BFF_REQUEST_STATUS_KEY"] = $61d8c334831b33b2$export$c889532d47d74e9c;
module.exports["FLIGHTDECK_REQUEST_STATUS_KEY"] = $61d8c334831b33b2$export$123b1b8742c0ac6a;
module.exports["UC_MENU_ITEMS_REQUEST_STATUS_KEY"] = $61d8c334831b33b2$export$1631e8a201b50246;

});

parcelRegister("iBJls", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ePvn = parcelRequire("3ePvn");

const $11aafb4b171e622f$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $11aafb4b171e622f$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $cozmU.createContext)({
    value: $11aafb4b171e622f$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: ()=>{}
});
const $11aafb4b171e622f$export$63342c357ecccda2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBFFContext() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($11aafb4b171e622f$export$873dcaf380a86d6b);
} : function useBFFContext() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($11aafb4b171e622f$export$873dcaf380a86d6b);
};
const $11aafb4b171e622f$export$71a938590b6955cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BFFProvider(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { consumer: consumer, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== consumer) {
        t2 = {
            cache: t1,
            cacheKey: consumer,
            consumer: consumer,
            status: (0, $3ePvn.RequestStatus).INIT
        };
        $[1] = consumer;
        $[2] = t2;
    } else t2 = $[2];
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[3] = t3;
    } else t3 = $[3];
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t3);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (name, status)=>{
            bb2: switch(status){
                case (0, $3ePvn.RequestStatus).LOADING:
                    setCurrentLoadingRequests((prev_0)=>[
                            ...prev_0,
                            name
                        ]);
                    break bb2;
                case (0, $3ePvn.RequestStatus).COMPLETE:
                    setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                    break bb2;
                case (0, $3ePvn.RequestStatus).ERROR:
                    setCurrentLoadingRequests([]);
            }
        };
        $[4] = t4;
    } else t4 = $[4];
    const updateCurrentLoadingRequests = t4;
    let t5;
    if ($[5] !== currentLoadingRequests || $[6] !== value) {
        t5 = {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        };
        $[5] = currentLoadingRequests;
        $[6] = value;
        $[7] = t5;
    } else t5 = $[7];
    const stableContextValue = t5;
    let t6;
    if ($[8] !== children || $[9] !== stableContextValue) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11aafb4b171e622f$export$873dcaf380a86d6b.Provider, {
            value: stableContextValue
        }, children);
        $[8] = children;
        $[9] = stableContextValue;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : function BFFProvider({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $3ePvn.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState([]);
    const updateCurrentLoadingRequests = (0, $cozmU.useCallback)((name, status)=>{
        switch(status){
            case (0, $3ePvn.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev_0)=>[
                        ...prev_0,
                        name
                    ]);
                break;
            case (0, $3ePvn.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $3ePvn.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    const stableContextValue = (0, $cozmU.useMemo)(()=>({
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        }), [
        currentLoadingRequests,
        updateCurrentLoadingRequests,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11aafb4b171e622f$export$873dcaf380a86d6b.Provider, {
        value: stableContextValue
    }, children);
};
const $11aafb4b171e622f$var$defaultUserControls = {
    user: undefined
};
const $11aafb4b171e622f$export$38ee920e59704589 = /*#__PURE__*/ (0, $cozmU.createContext)($11aafb4b171e622f$var$defaultUserControls);
const $11aafb4b171e622f$export$87c54b525b914dab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUserContext() {
    return (0, $cozmU.useContext)($11aafb4b171e622f$export$38ee920e59704589);
} : function useUserContext() {
    return (0, $cozmU.useContext)($11aafb4b171e622f$export$38ee920e59704589);
};
module.exports["BFFContext"] = $11aafb4b171e622f$export$873dcaf380a86d6b;
module.exports["useBFFContext"] = $11aafb4b171e622f$export$63342c357ecccda2;
module.exports["BFFProvider"] = $11aafb4b171e622f$export$71a938590b6955cc;
module.exports["useUserContext"] = $11aafb4b171e622f$export$87c54b525b914dab;

});

parcelRegister("cN3xQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4fwrR = parcelRequire("4fwrR");


var $8zSYe = parcelRequire("8zSYe");

var $f4dVw = parcelRequire("f4dVw");


var $1A5z7 = parcelRequire("1A5z7");

var $lPueq = parcelRequire("lPueq");

var $7rKTM = parcelRequire("7rKTM");

var $9Yk75 = parcelRequire("9Yk75");

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1f2cac9718387eef$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $21cRg = parcelRequire("21cRg");


var $husV7 = parcelRequire("husV7");

var $fvU8j = parcelRequire("fvU8j");

var $jCulH = parcelRequire("jCulH");

var $c9zD7 = parcelRequire("c9zD7");

var $6WvWU = parcelRequire("6WvWU");

/**
 * This function creates an exception from a JavaScript Error
 */ function $ad28a833a6c5806e$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $ad28a833a6c5806e$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $ad28a833a6c5806e$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $ad28a833a6c5806e$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $21cRg.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $jCulH.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $ad28a833a6c5806e$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $c9zD7.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $ad28a833a6c5806e$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $ad28a833a6c5806e$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $ad28a833a6c5806e$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $ad28a833a6c5806e$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $ad28a833a6c5806e$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $ad28a833a6c5806e$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $ad28a833a6c5806e$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($ad28a833a6c5806e$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $ad28a833a6c5806e$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $ad28a833a6c5806e$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $ad28a833a6c5806e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $husV7.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $6WvWU.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $ad28a833a6c5806e$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $ad28a833a6c5806e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $6WvWU.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $ad28a833a6c5806e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $jCulH.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $ad28a833a6c5806e$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $jCulH.isDOMError)(exception) || (0, $jCulH.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $ad28a833a6c5806e$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $jCulH.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $ad28a833a6c5806e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $husV7.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $jCulH.isError)(exception)) // we have a real Error object, do nothing
    return $ad28a833a6c5806e$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $jCulH.isPlainObject)(exception) || (0, $jCulH.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $ad28a833a6c5806e$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $husV7.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $ad28a833a6c5806e$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $husV7.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $husV7.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $ad28a833a6c5806e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $ad28a833a6c5806e$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $jCulH.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $ad28a833a6c5806e$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $fvU8j.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $jCulH.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $jCulH.isEvent)(exception)) {
        const className = $ad28a833a6c5806e$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $ad28a833a6c5806e$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}











var $ketRo = parcelRequire("ketRo");

const $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81 = (0, $ketRo.GLOBAL_OBJ);
let $cbaa93f0b0a58b8d$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $cbaa93f0b0a58b8d$export$b79738ab10c590b2() {
    return $cbaa93f0b0a58b8d$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $cbaa93f0b0a58b8d$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $cbaa93f0b0a58b8d$var$ignoreOnError++;
    setTimeout(()=>{
        $cbaa93f0b0a58b8d$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $cbaa93f0b0a58b8d$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $fvU8j.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$cbaa93f0b0a58b8d$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $cbaa93f0b0a58b8d$export$1265a142ff5ba165();
            (0, $21cRg.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $husV7.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $husV7.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $21cRg.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $fvU8j.markFunctionWrapped)(sentryWrapped, fn);
    (0, $fvU8j.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



var $9OC7c = parcelRequire("9OC7c");



/**
 * Creates an envelope from a user feedback.
 */ function $02915fa006cb574e$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $lPueq.dsnToString)(dsn)
        }
    };
    const item = $02915fa006cb574e$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $9OC7c.createEnvelope)(headers, [
        item
    ]);
}
function $02915fa006cb574e$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $2a5a6e69bbd83895$export$1df9218a526d318d extends (0, $f4dVw.BaseClient) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $ad28a833a6c5806e$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $ad28a833a6c5806e$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $02915fa006cb574e$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $1A5z7.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $lPueq.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $7rKTM.getSDKSource)();
        (0, $8zSYe.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document) (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
}


var $akjeV = parcelRequire("akjeV");

// global reference to slice
const $c926e031adfb6ad3$var$UNKNOWN_FUNCTION = '?';
const $c926e031adfb6ad3$var$OPERA10_PRIORITY = 10;
const $c926e031adfb6ad3$var$OPERA11_PRIORITY = 20;
const $c926e031adfb6ad3$var$CHROME_PRIORITY = 30;
const $c926e031adfb6ad3$var$WINJS_PRIORITY = 40;
const $c926e031adfb6ad3$var$GECKO_PRIORITY = 50;
function $c926e031adfb6ad3$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true // All browser frames are considered in_app
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $c926e031adfb6ad3$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $c926e031adfb6ad3$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $c926e031adfb6ad3$var$chromeStackParserFn = (line)=>{
    const parts = $c926e031adfb6ad3$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $c926e031adfb6ad3$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $c926e031adfb6ad3$var$extractSafariExtensionDetails(parts[1] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION, parts[2]);
        return $c926e031adfb6ad3$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $c926e031adfb6ad3$export$263a749fff749872 = [
    $c926e031adfb6ad3$var$CHROME_PRIORITY,
    $c926e031adfb6ad3$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $c926e031adfb6ad3$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $c926e031adfb6ad3$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $c926e031adfb6ad3$var$gecko = (line)=>{
    const parts = $c926e031adfb6ad3$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $c926e031adfb6ad3$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION;
        [func, filename] = $c926e031adfb6ad3$var$extractSafariExtensionDetails(func, filename);
        return $c926e031adfb6ad3$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $c926e031adfb6ad3$export$cdba47a5dd2804d = [
    $c926e031adfb6ad3$var$GECKO_PRIORITY,
    $c926e031adfb6ad3$var$gecko
];
const $c926e031adfb6ad3$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $c926e031adfb6ad3$var$winjs = (line)=>{
    const parts = $c926e031adfb6ad3$var$winjsRegex.exec(line);
    return parts ? $c926e031adfb6ad3$var$createFrame(parts[2], parts[1] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $c926e031adfb6ad3$export$179460296da408e8 = [
    $c926e031adfb6ad3$var$WINJS_PRIORITY,
    $c926e031adfb6ad3$var$winjs
];
const $c926e031adfb6ad3$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $c926e031adfb6ad3$var$opera10 = (line)=>{
    const parts = $c926e031adfb6ad3$var$opera10Regex.exec(line);
    return parts ? $c926e031adfb6ad3$var$createFrame(parts[2], parts[3] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $c926e031adfb6ad3$export$f892b52c880ffc7a = [
    $c926e031adfb6ad3$var$OPERA10_PRIORITY,
    $c926e031adfb6ad3$var$opera10
];
const $c926e031adfb6ad3$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $c926e031adfb6ad3$var$opera11 = (line)=>{
    const parts = $c926e031adfb6ad3$var$opera11Regex.exec(line);
    return parts ? $c926e031adfb6ad3$var$createFrame(parts[5], parts[3] || parts[4] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $c926e031adfb6ad3$export$af11af13f09fb0dc = [
    $c926e031adfb6ad3$var$OPERA11_PRIORITY,
    $c926e031adfb6ad3$var$opera11
];
const $c926e031adfb6ad3$export$7197c0fe6554c079 = [
    $c926e031adfb6ad3$export$263a749fff749872,
    $c926e031adfb6ad3$export$cdba47a5dd2804d,
    $c926e031adfb6ad3$export$179460296da408e8
];
const $c926e031adfb6ad3$export$2b2b997d81bf3907 = (0, $akjeV.createStackParser)(...$c926e031adfb6ad3$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $c926e031adfb6ad3$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $c926e031adfb6ad3$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




var $lzqTp = parcelRequire("lzqTp");

var $duU2C = parcelRequire("duU2C");

var $fWjB8 = parcelRequire("fWjB8");

var $6Svx4 = parcelRequire("6Svx4");

var $8e57t = parcelRequire("8e57t");

var $AcsET = parcelRequire("AcsET");


var $jYHGu = parcelRequire("jYHGu");





var $k6sEr = parcelRequire("k6sEr");










var $dRWPa = parcelRequire("dRWPa");

var $erpJl = parcelRequire("erpJl");

var $cLOuA = parcelRequire("cLOuA");



var $1C9Vl = parcelRequire("1C9Vl");

var $bVNqQ = parcelRequire("bVNqQ");





var $4e32G = parcelRequire("4e32G");

var $7xYxl = parcelRequire("7xYxl");

var $hVeUz = parcelRequire("hVeUz");



/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $10dac0e9633a2324$var$INTEGRATION_NAME = 'Breadcrumbs';
const $10dac0e9633a2324$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $10dac0e9633a2324$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        setup (client) {
            if (_options.console) (0, $erpJl.addConsoleInstrumentationHandler)($10dac0e9633a2324$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $dRWPa.addClickKeypressInstrumentationHandler)($10dac0e9633a2324$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $1C9Vl.addXhrInstrumentationHandler)($10dac0e9633a2324$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $cLOuA.addFetchInstrumentationHandler)($10dac0e9633a2324$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $jYHGu.addHistoryInstrumentationHandler)($10dac0e9633a2324$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $10dac0e9633a2324$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $10dac0e9633a2324$export$c079d904b326663a = (0, $fWjB8.defineIntegration)($10dac0e9633a2324$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $10dac0e9633a2324$export$2dc68d50d56fbbd = (0, $fWjB8.convertIntegrationFnToClass)($10dac0e9633a2324$var$INTEGRATION_NAME, $10dac0e9633a2324$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $10dac0e9633a2324$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $21cRg.getClient)() !== client) return;
        (0, $21cRg.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $husV7.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $10dac0e9633a2324$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $10dac0e9633a2324$var$_isEvent(event) ? event.target : event;
            target = (0, $bVNqQ.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $bVNqQ.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $21cRg.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $10dac0e9633a2324$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $hVeUz.severityLevelFromString)(handlerData.level),
            message: (0, $7xYxl.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $7xYxl.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $21cRg.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $10dac0e9633a2324$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $1C9Vl.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $21cRg.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $10dac0e9633a2324$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $21cRg.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $21cRg.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $10dac0e9633a2324$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $4e32G.parseUrl)((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $4e32G.parseUrl)(from) : undefined;
        const parsedTo = (0, $4e32G.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $21cRg.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $10dac0e9633a2324$var$_isEvent(event) {
    return !!event && !!event.target;
}









const $6e464f698cf23b39$var$INTEGRATION_NAME = 'Dedupe';
const $6e464f698cf23b39$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $6e464f698cf23b39$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($6e464f698cf23b39$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $6e464f698cf23b39$export$6d39aa44cd0c7567 = (0, $fWjB8.defineIntegration)($6e464f698cf23b39$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6e464f698cf23b39$export$688d98c249d31ad3 = (0, $fWjB8.convertIntegrationFnToClass)($6e464f698cf23b39$var$INTEGRATION_NAME, $6e464f698cf23b39$export$6d39aa44cd0c7567);
function $6e464f698cf23b39$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6e464f698cf23b39$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6e464f698cf23b39$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $6e464f698cf23b39$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6e464f698cf23b39$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6e464f698cf23b39$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6e464f698cf23b39$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $6e464f698cf23b39$var$_getExceptionFromEvent(previousEvent);
    const currentException = $6e464f698cf23b39$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6e464f698cf23b39$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6e464f698cf23b39$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6e464f698cf23b39$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $6e464f698cf23b39$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $6e464f698cf23b39$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $6e464f698cf23b39$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $6e464f698cf23b39$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $6e464f698cf23b39$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}








var $iUgAG = parcelRequire("iUgAG");

var $4ybu6 = parcelRequire("4ybu6");










/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $ca9fedbcf0954906$var$INTEGRATION_NAME = 'GlobalHandlers';
const $ca9fedbcf0954906$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $ca9fedbcf0954906$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $ca9fedbcf0954906$var$_installGlobalOnErrorHandler(client);
                $ca9fedbcf0954906$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $ca9fedbcf0954906$var$_installGlobalOnUnhandledRejectionHandler(client);
                $ca9fedbcf0954906$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $ca9fedbcf0954906$export$66acc70e8cf2b71a = (0, $fWjB8.defineIntegration)($ca9fedbcf0954906$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ca9fedbcf0954906$export$204155decbc90e5a = (0, $fWjB8.convertIntegrationFnToClass)($ca9fedbcf0954906$var$INTEGRATION_NAME, $ca9fedbcf0954906$export$66acc70e8cf2b71a);
function $ca9fedbcf0954906$var$_installGlobalOnErrorHandler(client) {
    (0, $iUgAG.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ca9fedbcf0954906$var$getOptions();
        if ((0, $21cRg.getClient)() !== client || (0, $cbaa93f0b0a58b8d$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $jCulH.isString)(msg) ? $ca9fedbcf0954906$var$_eventFromIncompleteOnError(msg, url, line, column) : $ca9fedbcf0954906$var$_enhanceEventWithInitialFrame((0, $ad28a833a6c5806e$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $21cRg.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $ca9fedbcf0954906$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $4ybu6.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ca9fedbcf0954906$var$getOptions();
        if ((0, $21cRg.getClient)() !== client || (0, $cbaa93f0b0a58b8d$export$b79738ab10c590b2)()) return;
        const error = $ca9fedbcf0954906$var$_getUnhandledRejectionError(e);
        const event = (0, $jCulH.isPrimitive)(error) ? $ca9fedbcf0954906$var$_eventFromRejectionWithPrimitive(error) : (0, $ad28a833a6c5806e$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $21cRg.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $ca9fedbcf0954906$var$_getUnhandledRejectionError(error) {
    if ((0, $jCulH.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $ca9fedbcf0954906$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca9fedbcf0954906$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $jCulH.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $ca9fedbcf0954906$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca9fedbcf0954906$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $jCulH.isString)(url) && url.length > 0 ? url : (0, $bVNqQ.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $ca9fedbcf0954906$var$globalHandlerLog(type) {
    (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).log(`Global Handler attached: ${type}`);
}
function $ca9fedbcf0954906$var$getOptions() {
    const client = (0, $21cRg.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}






const $50945a6a94f7a81c$var$INTEGRATION_NAME = 'HttpContext';
const $50945a6a94f7a81c$var$_httpContextIntegration = ()=>{
    return {
        name: $50945a6a94f7a81c$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).navigator && !(0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).location && !(0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).location && (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $50945a6a94f7a81c$export$1378794447170364 = (0, $fWjB8.defineIntegration)($50945a6a94f7a81c$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $50945a6a94f7a81c$export$5d2ee9a544b09a94 = (0, $fWjB8.convertIntegrationFnToClass)($50945a6a94f7a81c$var$INTEGRATION_NAME, $50945a6a94f7a81c$export$1378794447170364);






var $22PUP = parcelRequire("22PUP");


const $2269c81e135e40be$var$DEFAULT_KEY = 'cause';
const $2269c81e135e40be$var$DEFAULT_LIMIT = 5;
const $2269c81e135e40be$var$INTEGRATION_NAME = 'LinkedErrors';
const $2269c81e135e40be$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $2269c81e135e40be$var$DEFAULT_LIMIT;
    const key = options.key || $2269c81e135e40be$var$DEFAULT_KEY;
    return {
        name: $2269c81e135e40be$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $22PUP.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $ad28a833a6c5806e$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $2269c81e135e40be$export$ebabb00eb7f3a395 = (0, $fWjB8.defineIntegration)($2269c81e135e40be$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2269c81e135e40be$export$8d1e60aaf616fb4f = (0, $fWjB8.convertIntegrationFnToClass)($2269c81e135e40be$var$INTEGRATION_NAME, $2269c81e135e40be$export$ebabb00eb7f3a395);











const $90f1ef4dc1abcb9b$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $90f1ef4dc1abcb9b$var$INTEGRATION_NAME = 'TryCatch';
const $90f1ef4dc1abcb9b$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $90f1ef4dc1abcb9b$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $fvU8j.fill)((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81), 'setTimeout', $90f1ef4dc1abcb9b$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $fvU8j.fill)((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81), 'setInterval', $90f1ef4dc1abcb9b$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $fvU8j.fill)((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81), 'requestAnimationFrame', $90f1ef4dc1abcb9b$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81)) (0, $fvU8j.fill)(XMLHttpRequest.prototype, 'send', $90f1ef4dc1abcb9b$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $90f1ef4dc1abcb9b$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($90f1ef4dc1abcb9b$var$_wrapEventTarget);
            }
        }
    };
};
const $90f1ef4dc1abcb9b$export$59bfe9f1c76150e = (0, $fWjB8.defineIntegration)($90f1ef4dc1abcb9b$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $90f1ef4dc1abcb9b$export$f1a018517668e6d3 = (0, $fWjB8.convertIntegrationFnToClass)($90f1ef4dc1abcb9b$var$INTEGRATION_NAME, $90f1ef4dc1abcb9b$export$59bfe9f1c76150e);
function $90f1ef4dc1abcb9b$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $cbaa93f0b0a58b8d$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $akjeV.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $90f1ef4dc1abcb9b$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $cbaa93f0b0a58b8d$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $akjeV.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $90f1ef4dc1abcb9b$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $fvU8j.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $akjeV.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $fvU8j.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $akjeV.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $cbaa93f0b0a58b8d$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $90f1ef4dc1abcb9b$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $fvU8j.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $cbaa93f0b0a58b8d$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $akjeV.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $cbaa93f0b0a58b8d$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $akjeV.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $fvU8j.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}




var $lOoQm = parcelRequire("lOoQm");











let $d1630cae02990d96$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d1630cae02990d96$export$8be2119ce08e3379() {
    if ($d1630cae02990d96$var$cachedFetchImpl) return $d1630cae02990d96$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $k6sEr.isNativeFetch)((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).fetch)) return $d1630cae02990d96$var$cachedFetchImpl = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).fetch.bind((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81));
    const document = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $d1630cae02990d96$var$cachedFetchImpl = fetchImpl.bind((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $d1630cae02990d96$export$d499686d2dd738c6() {
    $d1630cae02990d96$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $57047c544855db8c$export$b2311068c46d7cc8(options, nativeFetch = (0, $d1630cae02990d96$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $d1630cae02990d96$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $6WvWU.rejectedSyncPromise)(e);
        }
    }
    return (0, $lOoQm.createTransport)(options, makeRequest);
}








/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $df555405e63989b1$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $df555405e63989b1$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $6WvWU.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $df555405e63989b1$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $lOoQm.createTransport)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $4f8f5dca3b792261$export$5ef831fccfce35e5 = [
    (0, $8e57t.inboundFiltersIntegration)(),
    (0, $lzqTp.functionToStringIntegration)(),
    (0, $90f1ef4dc1abcb9b$export$59bfe9f1c76150e)(),
    (0, $10dac0e9633a2324$export$c079d904b326663a)(),
    (0, $ca9fedbcf0954906$export$66acc70e8cf2b71a)(),
    (0, $2269c81e135e40be$export$ebabb00eb7f3a395)(),
    (0, $6e464f698cf23b39$export$6d39aa44cd0c7567)(),
    (0, $50945a6a94f7a81c$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $4f8f5dca3b792261$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$4f8f5dca3b792261$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4f8f5dca3b792261$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4f8f5dca3b792261$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $akjeV.stackParserFromStackParserOptions)(options.stackParser || (0, $c926e031adfb6ad3$export$2b2b997d81bf3907)),
        integrations: (0, $fWjB8.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $k6sEr.supportsFetch)() ? (0, $57047c544855db8c$export$b2311068c46d7cc8) : (0, $df555405e63989b1$export$5e1441cee30d5a39))
    };
    (0, $AcsET.initAndBind)((0, $2a5a6e69bbd83895$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $4f8f5dca3b792261$var$startSessionTracking();
}
const $4f8f5dca3b792261$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $duU2C.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document) {
        (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $6Svx4.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document.head || (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4f8f5dca3b792261$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4f8f5dca3b792261$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4f8f5dca3b792261$export$4997ffc0176396a6(fn) {
    return (0, $cbaa93f0b0a58b8d$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4f8f5dca3b792261$var$startSessionTracking() {
    if (typeof (0, $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $1f2cac9718387eef$export$16a28057038b10ef) && (0, $9Yk75.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $21cRg.startSession)({
        ignoreDuration: true
    });
    (0, $21cRg.captureSession)();
    // We want to create a session for every navigation as well
    (0, $jYHGu.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $21cRg.startSession)({
                ignoreDuration: true
            });
            (0, $21cRg.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $4f8f5dca3b792261$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $21cRg.getClient)();
    if (client) client.captureUserFeedback(feedback);
}


var $kzeX8 = parcelRequire("kzeX8");


var $iDrrr = parcelRequire("iDrrr");


var $5D2Vi = parcelRequire("5D2Vi");

var $cf10c8edb5d48b94$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});


const $1c6adf460a912312$export$636c0c57a2ce36e9 = {
    localhost: (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Development,
    '127.0.0.1': (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Development,
    'id.atlassian.com': (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod,
    'admin.atlassian.com': (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod,
    'id.stg.internal.atlassian.com': (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging,
    'admin.stg.atlassian.com': (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging
};



function $61987beec044a597$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $1c6adf460a912312$export$636c0c57a2ce36e9)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $61987beec044a597$var$classifyComDomain(host);
        case 'net':
            return $61987beec044a597$var$classifyNetDomain(host);
        default:
            return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $61987beec044a597$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging : (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging;
        return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging;
        return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod;
    }
    return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Unknown;
}
/**
 * Classify .net domains
 */ function $61987beec044a597$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging;
        if (host.includes('.prod.')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod;
        return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Development;
            if (host.includes('.stg-east.')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging;
            if (host.includes('.prod-east.')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod;
            return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Development;
        if (host.includes('.staging.')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Staging;
        if (host.includes('.prod.')) return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Prod;
    }
    return (0, $cf10c8edb5d48b94$export$7dc6752a22ab011a).Unknown;
}


// Navigation-experience Sentry DSN
const $5f989899057c4a5a$export$6faa4a850bc4d0ce = 'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';
const $5f989899057c4a5a$export$eafddbd5a5d6fa6a = 'afe-navigation-experience';
const $5f989899057c4a5a$export$3a6a639b0dcb30fa = [
    // Browser-level network failures
    /Failed to fetch$/i,
    // Chromium
    /NetworkError when attempting to fetch/i,
    // Firefox
    /Load failed$/i,
    // Safari
    /AbortError/i,
    /The user aborted a request/i,
    /^Failed to fetch data:/i,
    /^BFF_NETWORK_ERROR:/i,
    /^RelayNetwork: No data returned for operation/i,
    /^FetchError:/i,
    /^Error getting available products by site/i
];
const $5f989899057c4a5a$export$52d764e0fd2a1dc5 = {
    whitelistUrls: [
        /atl-paas.net/,
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/
    ],
    ignoreUrls: [
        /extensions\//i,
        /^chrome:\/\//i
    ],
    attachStacktrace: true
};
const $5f989899057c4a5a$export$9f448e5ee63d7699 = 'navigation';


let $f99dbbf2ed634000$var$sentryClient;
let $f99dbbf2ed634000$var$scope = new (0, $kzeX8.Scope)();
function $f99dbbf2ed634000$export$ef31311040ebdb46(event) {
    const exceptionValue = event.exception?.values?.[0]?.value ?? '';
    const candidates = [
        exceptionValue,
        event.message ?? ''
    ].filter(Boolean);
    if (candidates.length > 0 && (0, $5f989899057c4a5a$export$3a6a639b0dcb30fa).some((re)=>candidates.some((c)=>re.test(c)))) return true;
    // BFFNetworkError 5xx via flattened scope.extras (set by logException)
    const extras = event.extra;
    if (extras?.name === 'BFF_NETWORK_ERROR') {
        const status = Number(extras.status);
        if (!Number.isNaN(status) && status >= 500) return true;
    }
    return false;
}
function $f99dbbf2ed634000$export$f86b2a1a2ce291b3(exception, tags) {
    $f99dbbf2ed634000$var$scope.setTags(tags);
    if (exception instanceof (0, $5D2Vi.BFFError)) {
        const error = exception;
        $f99dbbf2ed634000$var$scope.setExtras({
            name: error.name,
            context: error.context,
            status: error.status,
            timestamp: error.timestamp,
            originalError: error.originalError,
            ...error instanceof (0, $5D2Vi.BFFNetworkError) && {
                url: error.url
            }
        });
    }
    $f99dbbf2ed634000$var$sentryClient?.captureException(exception, undefined, $f99dbbf2ed634000$var$scope);
    // Unset tags to prevent an instance of the error boundary from logging with a specific tag,
    // and then another instance from wrongly passing it despite not having the tag.
    for (const [key, _] of Object.entries(tags))$f99dbbf2ed634000$var$scope.setTag(key, undefined);
    // Unset any extras to prevent them from persisting
    $f99dbbf2ed634000$var$scope.setExtras({});
}
function $f99dbbf2ed634000$export$d8bd0edf6c978788({ sentryConfig: sentryConfig }) {
    const { dsn: dsn = (0, $5f989899057c4a5a$export$6faa4a850bc4d0ce), env: env } = sentryConfig || {};
    if (!$f99dbbf2ed634000$var$sentryClient) {
        // SSR-safe check. If we are in SSR, we don't need a sentryClient
        if (typeof window === 'undefined') return false;
        const environment = (0, $61987beec044a597$export$57570b1603cf6adb)(env);
        // filter integrations that use the global variable
        const integrations = (0, $4f8f5dca3b792261$export$5783b2920b1d62b9)({}).filter((defaultIntegration)=>{
            return ![
                'BrowserApiErrors',
                'Breadcrumbs',
                'GlobalHandlers'
            ].includes(defaultIntegration.name);
        });
        // NAVX-4946: gate BE-noise suppression behind a feature flag.
        const isSentryFilteringEnabled = (0, $iDrrr.fg)('navx-4946-sentry-filtering');
        $f99dbbf2ed634000$var$sentryClient = new (0, $2a5a6e69bbd83895$export$1df9218a526d318d)({
            ...(0, $5f989899057c4a5a$export$52d764e0fd2a1dc5),
            ignoreErrors: isSentryFilteringEnabled ? [
                ...(0, $5f989899057c4a5a$export$52d764e0fd2a1dc5).ignoreErrors,
                ...(0, $5f989899057c4a5a$export$3a6a639b0dcb30fa)
            ] : (0, $5f989899057c4a5a$export$52d764e0fd2a1dc5).ignoreErrors,
            dsn: dsn,
            environment: environment,
            beforeSend: (event)=>{
                // Only events captured via logException (which sets teamName)
                if (event.tags?.teamName === undefined) return null;
                if (isSentryFilteringEnabled && $f99dbbf2ed634000$export$ef31311040ebdb46(event)) return null;
                return event;
            },
            attachStacktrace: true,
            transport: (0, $57047c544855db8c$export$b2311068c46d7cc8),
            stackParser: (0, $c926e031adfb6ad3$export$2b2b997d81bf3907),
            integrations: integrations
        });
        $f99dbbf2ed634000$var$scope.setClient($f99dbbf2ed634000$var$sentryClient);
        $f99dbbf2ed634000$var$sentryClient.init();
    }
    return true;
}
function $f99dbbf2ed634000$export$64db7b418e82aaf6() {
    $f99dbbf2ed634000$var$sentryClient = undefined;
    $f99dbbf2ed634000$var$scope = new (0, $kzeX8.Scope)();
}



const $b1867ebd3a377ce5$export$335b0c12ccf77339 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavBoundaryContext(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { location: t1, disableSentry: t2, disableAnalytics: t3, onError: onError, sentryConfig: sentryConfig, tags: tags } = t0 === undefined ? {} : t0;
    const location = t1 === undefined ? "unknown" : t1;
    const disableSentry = t2 === undefined ? false : t2;
    const disableAnalytics = t3 === undefined ? false : t3;
    const { fireEvent: fireEvent } = (0, $4fwrR.useAnalyticsEvents)();
    if (!disableSentry) try {
        (0, $f99dbbf2ed634000$export$d8bd0edf6c978788)({
            sentryConfig: sentryConfig
        });
    } catch (t4) {
        const error = t4;
        fireEvent("operational.initSentry.failed", {
            location: location,
            reason: error instanceof Error ? error.message : "unknown"
        });
    }
    sentryConfig?.product;
    const t4 = sentryConfig?.product ?? (0, $5f989899057c4a5a$export$9f448e5ee63d7699);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = $b1867ebd3a377ce5$var$getProductBuild();
        $[0] = t5;
    } else t5 = $[0];
    let t6;
    if ($[1] !== location || $[2] !== t4 || $[3] !== tags) {
        t6 = {
            ...tags,
            location: location,
            teamName: (0, $5f989899057c4a5a$export$eafddbd5a5d6fa6a),
            product: t4,
            productBuild: t5
        };
        $[1] = location;
        $[2] = t4;
        $[3] = tags;
        $[4] = t6;
    } else t6 = $[4];
    const tagsToLog = t6;
    let t7;
    if ($[5] !== disableAnalytics || $[6] !== disableSentry || $[7] !== fireEvent || $[8] !== location || $[9] !== onError || $[10] !== tagsToLog) {
        t7 = (error_0)=>{
            if (!disableSentry) try {
                (0, $f99dbbf2ed634000$export$f86b2a1a2ce291b3)(error_0, tagsToLog);
            } catch (t8) {
                const err = t8;
                fireEvent("operational.logToSentry.failed", {
                    location: location,
                    reason: err instanceof Error ? err.message : "unknown"
                });
            }
            if (!disableAnalytics) fireEvent("operational.errorBoundary.unhandledErrorCaught", {
                location: location,
                errorMessage: error_0.message,
                errorStack: error_0.stack || "no stack trace"
            });
            onError?.(error_0);
        };
        $[5] = disableAnalytics;
        $[6] = disableSentry;
        $[7] = fireEvent;
        $[8] = location;
        $[9] = onError;
        $[10] = tagsToLog;
        $[11] = t7;
    } else t7 = $[11];
    const handleError = t7;
    let t8;
    if ($[12] !== handleError) {
        t8 = {
            handleError: handleError
        };
        $[12] = handleError;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : function useNavBoundaryContext({ location: location = 'unknown', disableSentry: disableSentry = false, disableAnalytics: disableAnalytics = false, onError: onError, sentryConfig: sentryConfig, tags: tags } = {}) {
    const { fireEvent: fireEvent } = (0, $4fwrR.useAnalyticsEvents)();
    if (!disableSentry) try {
        (0, $f99dbbf2ed634000$export$d8bd0edf6c978788)({
            sentryConfig: sentryConfig
        });
    } catch (error) {
        // Log failure to initialize Sentry
        fireEvent('operational.initSentry.failed', {
            location: location,
            reason: error instanceof Error ? error.message : 'unknown'
        });
    }
    const tagsToLog = (0, $cozmU.useMemo)(()=>{
        return {
            ...tags,
            location: location,
            teamName: (0, $5f989899057c4a5a$export$eafddbd5a5d6fa6a),
            product: sentryConfig?.product ?? (0, $5f989899057c4a5a$export$9f448e5ee63d7699),
            productBuild: $b1867ebd3a377ce5$var$getProductBuild()
        };
    }, [
        tags,
        location,
        sentryConfig?.product
    ]);
    const handleError = (0, $cozmU.useCallback)((error_0)=>{
        // Send events to sentry
        if (!disableSentry) try {
            (0, $f99dbbf2ed634000$export$f86b2a1a2ce291b3)(error_0, tagsToLog);
        } catch (err) {
            // Log failure to send to Sentry
            fireEvent('operational.logToSentry.failed', {
                location: location,
                reason: err instanceof Error ? err.message : 'unknown'
            });
        }
        // Fire Analytics event
        if (!disableAnalytics) fireEvent('operational.errorBoundary.unhandledErrorCaught', {
            location: location,
            errorMessage: error_0.message,
            errorStack: error_0.stack || 'no stack trace'
        });
        // Invoke external onError
        onError?.(error_0);
    }, [
        disableSentry,
        disableAnalytics,
        onError,
        location,
        tagsToLog,
        fireEvent
    ]);
    return {
        handleError: handleError
    };
};
function $b1867ebd3a377ce5$var$getProductBuild() {
    // Ensure we don't invoke window object in SSR
    if (typeof window === 'undefined') return 'unknown';
    switch(true){
        // Jira - window.BUILD_KEY
        case 'BUILD_KEY' in window:
            return window.BUILD_KEY || 'unknown';
        // Confluence - window.__buildInfo
        case '__buildInfo' in window:
            return window.__buildInfo?.FRONTEND_VERSION || 'unknown';
        default:
            return 'unknown';
    }
}
module.exports["useNavBoundaryContext"] = $b1867ebd3a377ce5$export$335b0c12ccf77339;

});

parcelRegister("4fwrR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $8d3a8f742341084f$export$3f072f06b90c3985 = 'navigation';


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::85436479424fa726e1c817d9c4b6af72>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen navigation-common
 */ const $263f41c0f74fa853$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $263f41c0f74fa853$export$2e2bcd8739ae039 = $263f41c0f74fa853$var$createEventPayload;


const $30cfe5bdec878b29$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $263f41c0f74fa853$export$2e2bcd8739ae039)(...params));
            event.fire((0, $8d3a8f742341084f$export$3f072f06b90c3985));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    const t1 = fireEvent;
    let t2;
    if ($[2] !== t1) {
        t2 = {
            fireEvent: t1
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $263f41c0f74fa853$export$2e2bcd8739ae039)(...params));
        event.fire((0, $8d3a8f742341084f$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $30cfe5bdec878b29$export$5bf35293e545f20c;

});

parcelRegister("8zSYe", function(module, exports) {

var $9r9CU = parcelRequire("9r9CU");

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $63ec3b95fd3257e8$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $9r9CU.SDK_VERSION)
            })),
        version: (0, $9r9CU.SDK_VERSION)
    };
    options._metadata = metadata;
}
 //# sourceMappingURL=sdkMetadata.js.map
module.exports["applySdkMetadata"] = $63ec3b95fd3257e8$export$b9f95b027256052c;

});

parcelRegister("f4dVw", function(module, exports) {

var $9OC7c = parcelRequire("9OC7c");

var $husV7 = parcelRequire("husV7");

var $jCulH = parcelRequire("jCulH");

var $9Yk75 = parcelRequire("9Yk75");

var $lPueq = parcelRequire("lPueq");

var $6WvWU = parcelRequire("6WvWU");

var $clOWD = parcelRequire("clOWD");


var $6Svx4 = parcelRequire("6Svx4");


var $6y8WD = parcelRequire("6y8WD");






/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $8bca48ff94fd5244$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $8bca48ff94fd5244$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $9OC7c.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $lPueq.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $9OC7c.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $8bca48ff94fd5244$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $9OC7c.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $8bca48ff94fd5244$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $9OC7c.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $9OC7c.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
 //# sourceMappingURL=envelope.js.map



var $21cRg = parcelRequire("21cRg");


var $duU2C = parcelRequire("duU2C");


var $fWjB8 = parcelRequire("fWjB8");







var $fvU8j = parcelRequire("fvU8j");

/**
 * Generate bucket key from metric properties.
 */ function $482313107a38ff28$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $fvU8j.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $482313107a38ff28$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $482313107a38ff28$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $482313107a38ff28$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $482313107a38ff28$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $482313107a38ff28$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $482313107a38ff28$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        "\\u{7c}"
    ],
    [
        ',',
        "\\u{2c}"
    ]
];
function $482313107a38ff28$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $482313107a38ff28$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $482313107a38ff28$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $482313107a38ff28$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $482313107a38ff28$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $482313107a38ff28$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $482313107a38ff28$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}
 //# sourceMappingURL=utils.js.map


/**
 * Create envelope from a metric aggregate.
 */ function $5f84ac5b27d14a72$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $lPueq.dsnToString)(dsn);
    const item = $5f84ac5b27d14a72$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $9OC7c.createEnvelope)(headers, [
        item
    ]);
}
function $5f84ac5b27d14a72$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $482313107a38ff28$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}
 //# sourceMappingURL=envelope.js.map



var $jCzb2 = parcelRequire("jCzb2");


var $lryW8 = parcelRequire("lryW8");


var $gkXQu = parcelRequire("gkXQu");

const $af82084e2e16e4c0$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $af82084e2e16e4c0$export$4f22f74eddb7716a {
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $husV7.checkOrSetAlreadyCaught)(exception)) {
            (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).log($af82084e2e16e4c0$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $jCulH.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $jCulH.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $husV7.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).log($af82084e2e16e4c0$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $jCzb2.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $6WvWU.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fWjB8.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fWjB8.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $8bca48ff94fd5244$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $9OC7c.addItemToEnvelope)(env, (0, $9OC7c.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $8bca48ff94fd5244$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $5f84ac5b27d14a72$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fWjB8.setupIntegrations)(this, integrations);
        (0, $fWjB8.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $jCzb2.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $6WvWU.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $duU2C.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $gkXQu.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $lryW8.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $6y8WD.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $9Yk75.logger).log(sentryError.message);
                else (0, $9Yk75.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $af82084e2e16e4c0$var$isTransactionEvent(event);
        const isError = $af82084e2e16e4c0$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $6WvWU.rejectedSyncPromise)(new (0, $clOWD.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $clOWD.SentryError)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $af82084e2e16e4c0$var$processBeforeSend(options, prepared, hint);
            return $af82084e2e16e4c0$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $clOWD.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $clOWD.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $clOWD.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).error('Error while sending event:', reason);
        });
        else (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $lPueq.makeDsn)(options.dsn);
        else (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $6Svx4.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $af82084e2e16e4c0$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $jCulH.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $jCulH.isPlainObject)(event) && event !== null) throw new (0, $clOWD.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $clOWD.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $jCulH.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $clOWD.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $af82084e2e16e4c0$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($af82084e2e16e4c0$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($af82084e2e16e4c0$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $af82084e2e16e4c0$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $af82084e2e16e4c0$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $af82084e2e16e4c0$export$9aac0b9f77928fbf(callback) {
    const client = (0, $21cRg.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}
 //# sourceMappingURL=baseclient.js.map
module.exports["BaseClient"] = $af82084e2e16e4c0$export$4f22f74eddb7716a;

});

parcelRegister("9OC7c", function(module, exports) {

var $lPueq = parcelRequire("lPueq");


var $c9zD7 = parcelRequire("c9zD7");


var $fvU8j = parcelRequire("fvU8j");

/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $725659694b6355d7$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $725659694b6355d7$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $725659694b6355d7$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $725659694b6355d7$export$604a45d95a155e2b(envelope, types) {
    return $725659694b6355d7$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $725659694b6355d7$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $725659694b6355d7$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $725659694b6355d7$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $725659694b6355d7$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $c9zD7.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $725659694b6355d7$var$concatBuffers(parts);
}
function $725659694b6355d7$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $725659694b6355d7$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $725659694b6355d7$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $725659694b6355d7$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $fvU8j.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $725659694b6355d7$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $725659694b6355d7$export$b11169581eeaf237(type) {
    return $725659694b6355d7$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $725659694b6355d7$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $725659694b6355d7$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $lPueq.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $fvU8j.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}
 //# sourceMappingURL=envelope.js.map
module.exports["createEnvelope"] = $725659694b6355d7$export$f93f7f385160c44e;
module.exports["addItemToEnvelope"] = $725659694b6355d7$export$d650323442802f6f;
module.exports["forEachEnvelopeItem"] = $725659694b6355d7$export$c56c55acf0136fd3;
module.exports["serializeEnvelope"] = $725659694b6355d7$export$32f9b428425aac85;
module.exports["createAttachmentEnvelopeItem"] = $725659694b6355d7$export$d8fc80952cc31fa4;
module.exports["envelopeItemTypeToDataCategory"] = $725659694b6355d7$export$b11169581eeaf237;
module.exports["getSdkMetadataForEnvelopeHeader"] = $725659694b6355d7$export$d369f3b2758f6743;
module.exports["createEventEnvelopeHeaders"] = $725659694b6355d7$export$92b6093782fe661b;

});

parcelRegister("lPueq", function(module, exports) {

var $iG9R2 = parcelRequire("iG9R2");


var $9Yk75 = parcelRequire("9Yk75");

/** Regular expression used to parse a Dsn. */ const $fe45cfbfad82f011$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $fe45cfbfad82f011$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $fe45cfbfad82f011$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $fe45cfbfad82f011$export$b892860177f70a30(str) {
    const match = $fe45cfbfad82f011$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $9Yk75.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $fe45cfbfad82f011$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $fe45cfbfad82f011$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $fe45cfbfad82f011$var$validateDsn(dsn) {
    if (!(0, $iG9R2.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $9Yk75.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $9Yk75.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$fe45cfbfad82f011$var$isValidProtocol(protocol)) {
        (0, $9Yk75.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $9Yk75.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $fe45cfbfad82f011$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $fe45cfbfad82f011$export$b892860177f70a30(from) : $fe45cfbfad82f011$var$dsnFromComponents(from);
    if (!components || !$fe45cfbfad82f011$var$validateDsn(components)) return undefined;
    return components;
}
 //# sourceMappingURL=dsn.js.map
module.exports["dsnToString"] = $fe45cfbfad82f011$export$44d472fbb931a776;
module.exports["makeDsn"] = $fe45cfbfad82f011$export$128827c3562ec0cb;

});

parcelRegister("9Yk75", function(module, exports) {

var $iG9R2 = parcelRequire("iG9R2");


var $ketRo = parcelRequire("ketRo");

/** Prefix for logging strings */ const $742951b9d46856ca$var$PREFIX = 'Sentry Logger ';
const $742951b9d46856ca$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $742951b9d46856ca$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $742951b9d46856ca$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $ketRo.GLOBAL_OBJ))) return callback();
    const console = (0, $ketRo.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($742951b9d46856ca$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $742951b9d46856ca$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $742951b9d46856ca$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $iG9R2.DEBUG_BUILD) $742951b9d46856ca$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $742951b9d46856ca$export$cda52e2a8927a2ca(()=>{
                (0, $ketRo.GLOBAL_OBJ).console[name](`${$742951b9d46856ca$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $742951b9d46856ca$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $742951b9d46856ca$export$af88d00dbe7f521 = $742951b9d46856ca$var$makeLogger();
 //# sourceMappingURL=logger.js.map
module.exports["CONSOLE_LEVELS"] = $742951b9d46856ca$export$2a2b1d2252a69ecb;
module.exports["originalConsoleMethods"] = $742951b9d46856ca$export$77c4ce905194557b;
module.exports["consoleSandbox"] = $742951b9d46856ca$export$cda52e2a8927a2ca;
module.exports["logger"] = $742951b9d46856ca$export$af88d00dbe7f521;

});

parcelRegister("ketRo", function(module, exports) {
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $ebac4710cf17476a$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $ebac4710cf17476a$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $ebac4710cf17476a$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $ebac4710cf17476a$var$isGlobalObj(window) || typeof self == 'object' && $ebac4710cf17476a$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $ebac4710cf17476a$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $ebac4710cf17476a$export$256479dc0cea61c4() {
    return $ebac4710cf17476a$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $ebac4710cf17476a$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $ebac4710cf17476a$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
 //# sourceMappingURL=worldwide.js.map
module.exports["GLOBAL_OBJ"] = $ebac4710cf17476a$export$f1a6cdb1459e81d1;
module.exports["getGlobalObject"] = $ebac4710cf17476a$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $ebac4710cf17476a$export$7e223ec222791509;

});

parcelRegister("c9zD7", function(module, exports) {

var $jCulH = parcelRequire("jCulH");

/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $fb6ac51760bb6b79$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}
 //# sourceMappingURL=memo.js.map



var $fvU8j = parcelRequire("fvU8j");


var $akjeV = parcelRequire("akjeV");

/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8d91f6a48d5a3865$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $8d91f6a48d5a3865$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $8d91f6a48d5a3865$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $8d91f6a48d5a3865$export$a3295358bff77e(object, depth);
    if ($8d91f6a48d5a3865$var$jsonSize(normalized) > maxSize) return $8d91f6a48d5a3865$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $8d91f6a48d5a3865$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $fb6ac51760bb6b79$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $jCulH.isNaN)(value)) return value;
    const stringified = $8d91f6a48d5a3865$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $8d91f6a48d5a3865$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $fvU8j.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $8d91f6a48d5a3865$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $8d91f6a48d5a3865$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $jCulH.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $jCulH.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $akjeV.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $8d91f6a48d5a3865$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $8d91f6a48d5a3865$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $8d91f6a48d5a3865$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8d91f6a48d5a3865$var$jsonSize(value) {
    return $8d91f6a48d5a3865$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $8d91f6a48d5a3865$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
 //# sourceMappingURL=normalize.js.map
module.exports["normalize"] = $8d91f6a48d5a3865$export$a3295358bff77e;
module.exports["normalizeToSize"] = $8d91f6a48d5a3865$export$23fbbb20bed71033;

});

parcelRegister("jCulH", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/unbound-method
const $e4891b9a82a7d53b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$e6127cc7fe7395c3(wat) {
    switch($e4891b9a82a7d53b$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $e4891b9a82a7d53b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$var$isBuiltin(wat, className) {
    return $e4891b9a82a7d53b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$9f9636d330b71954(wat) {
    return $e4891b9a82a7d53b$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$ef9e2056653f0c8e(wat) {
    return $e4891b9a82a7d53b$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$12e869b2a583f783(wat) {
    return $e4891b9a82a7d53b$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$844ec244b1367d54(wat) {
    return $e4891b9a82a7d53b$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$c3825b437cbdea5c(wat) {
    return wat === null || $e4891b9a82a7d53b$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$53b83ca8eaab0383(wat) {
    return $e4891b9a82a7d53b$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $e4891b9a82a7d53b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $e4891b9a82a7d53b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$49841c62b9eff15(wat) {
    return $e4891b9a82a7d53b$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $e4891b9a82a7d53b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$bc2894c7158efbac(wat) {
    return $e4891b9a82a7d53b$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e4891b9a82a7d53b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
 //# sourceMappingURL=is.js.map
module.exports["isError"] = $e4891b9a82a7d53b$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $e4891b9a82a7d53b$export$49034edbe6b62415;
module.exports["isErrorEvent"] = $e4891b9a82a7d53b$export$9f9636d330b71954;
module.exports["isDOMError"] = $e4891b9a82a7d53b$export$ef9e2056653f0c8e;
module.exports["isDOMException"] = $e4891b9a82a7d53b$export$12e869b2a583f783;
module.exports["isString"] = $e4891b9a82a7d53b$export$844ec244b1367d54;
module.exports["isParameterizedString"] = $e4891b9a82a7d53b$export$dbcbffa59149b824;
module.exports["isPrimitive"] = $e4891b9a82a7d53b$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $e4891b9a82a7d53b$export$53b83ca8eaab0383;
module.exports["isEvent"] = $e4891b9a82a7d53b$export$9671ea99bd126ace;
module.exports["isElement"] = $e4891b9a82a7d53b$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $e4891b9a82a7d53b$export$49841c62b9eff15;
module.exports["isThenable"] = $e4891b9a82a7d53b$export$f5b060c2914b97c8;
module.exports["isSyntheticEvent"] = $e4891b9a82a7d53b$export$bc2894c7158efbac;
module.exports["isNaN"] = $e4891b9a82a7d53b$export$c9f5652083b8129d;
module.exports["isVueViewModel"] = $e4891b9a82a7d53b$export$7916fad0ebc23f48;

});

parcelRegister("fvU8j", function(module, exports) {

var $bVNqQ = parcelRequire("bVNqQ");


var $iG9R2 = parcelRequire("iG9R2");


var $jCulH = parcelRequire("jCulH");


var $9Yk75 = parcelRequire("9Yk75");


var $7xYxl = parcelRequire("7xYxl");

/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $b4b54b19302c64b2$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $b4b54b19302c64b2$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $b4b54b19302c64b2$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $iG9R2.DEBUG_BUILD) && (0, $9Yk75.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $b4b54b19302c64b2$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $b4b54b19302c64b2$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $b4b54b19302c64b2$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $b4b54b19302c64b2$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $b4b54b19302c64b2$export$62ff257738bf57f5(value) {
    if ((0, $jCulH.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$b4b54b19302c64b2$var$getOwnProperties(value)
    };
    else if ((0, $jCulH.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $b4b54b19302c64b2$var$serializeEventTarget(value.target),
            currentTarget: $b4b54b19302c64b2$var$serializeEventTarget(value.currentTarget),
            ...$b4b54b19302c64b2$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $jCulH.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $b4b54b19302c64b2$var$serializeEventTarget(target) {
    try {
        return (0, $jCulH.isElement)(target) ? (0, $bVNqQ.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $b4b54b19302c64b2$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $b4b54b19302c64b2$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($b4b54b19302c64b2$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $7xYxl.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $7xYxl.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $b4b54b19302c64b2$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $b4b54b19302c64b2$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $b4b54b19302c64b2$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($b4b54b19302c64b2$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $b4b54b19302c64b2$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($b4b54b19302c64b2$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $b4b54b19302c64b2$var$isPojo(input) {
    if (!(0, $jCulH.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $b4b54b19302c64b2$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $jCulH.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
 //# sourceMappingURL=object.js.map
module.exports["fill"] = $b4b54b19302c64b2$export$9563e054e6f787fb;
module.exports["markFunctionWrapped"] = $b4b54b19302c64b2$export$5c1499e2e5d010ae;
module.exports["addNonEnumerableProperty"] = $b4b54b19302c64b2$export$e73679ffaf56810e;
module.exports["getOriginalFunction"] = $b4b54b19302c64b2$export$e6cc1e135e2092e5;
module.exports["urlEncode"] = $b4b54b19302c64b2$export$9ef804feabbcbaf1;
module.exports["convertToPlainObject"] = $b4b54b19302c64b2$export$62ff257738bf57f5;
module.exports["extractExceptionKeysForMessage"] = $b4b54b19302c64b2$export$b0244d5063c0b61b;
module.exports["dropUndefinedKeys"] = $b4b54b19302c64b2$export$d25f2688db1bb433;

});

parcelRegister("bVNqQ", function(module, exports) {

var $jCulH = parcelRequire("jCulH");


var $ketRo = parcelRequire("ketRo");

// eslint-disable-next-line deprecation/deprecation
const $8afb5cc147e9be1f$var$WINDOW = (0, $ketRo.getGlobalObject)();
const $8afb5cc147e9be1f$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8afb5cc147e9be1f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8afb5cc147e9be1f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8afb5cc147e9be1f$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8afb5cc147e9be1f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($8afb5cc147e9be1f$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $jCulH.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $8afb5cc147e9be1f$export$1cfafeee2987818b() {
    try {
        return $8afb5cc147e9be1f$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8afb5cc147e9be1f$export$c660c1f3ab49225c(selector) {
    if ($8afb5cc147e9be1f$var$WINDOW.document && $8afb5cc147e9be1f$var$WINDOW.document.querySelector) return $8afb5cc147e9be1f$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $8afb5cc147e9be1f$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$8afb5cc147e9be1f$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}
 //# sourceMappingURL=browser.js.map
module.exports["htmlTreeAsString"] = $8afb5cc147e9be1f$export$5647df6b7814ac86;
module.exports["getLocationHref"] = $8afb5cc147e9be1f$export$1cfafeee2987818b;
module.exports["getComponentName"] = $8afb5cc147e9be1f$export$26727cfcc4d7e0fc;

});

parcelRegister("7xYxl", function(module, exports) {

var $jCulH = parcelRequire("jCulH");

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $57ea92d211d261cf$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $57ea92d211d261cf$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $57ea92d211d261cf$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $jCulH.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $57ea92d211d261cf$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $jCulH.isString)(value)) return false;
    if ((0, $jCulH.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $jCulH.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $57ea92d211d261cf$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$57ea92d211d261cf$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}
 //# sourceMappingURL=string.js.map
module.exports["truncate"] = $57ea92d211d261cf$export$6a506b36fdea397d;
module.exports["snipLine"] = $57ea92d211d261cf$export$4215662d762d6f9d;
module.exports["safeJoin"] = $57ea92d211d261cf$export$465e9d514283d4fd;
module.exports["stringMatchesSomePattern"] = $57ea92d211d261cf$export$a7a5ec66062ea5d;

});

parcelRegister("akjeV", function(module, exports) {
/**
 * Does this filename look like it's part of the app code?
 */ function $d6107acbb7de4bd3$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $d6107acbb7de4bd3$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $d6107acbb7de4bd3$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}
 //# sourceMappingURL=node-stack-trace.js.map


const $784ab2413af623c7$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $784ab2413af623c7$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $784ab2413af623c7$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $784ab2413af623c7$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $784ab2413af623c7$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($784ab2413af623c7$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $784ab2413af623c7$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $784ab2413af623c7$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $784ab2413af623c7$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $784ab2413af623c7$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $784ab2413af623c7$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($784ab2413af623c7$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($784ab2413af623c7$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $784ab2413af623c7$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $784ab2413af623c7$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $784ab2413af623c7$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $784ab2413af623c7$var$defaultFunctionName;
        return fn.name || $784ab2413af623c7$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $784ab2413af623c7$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $784ab2413af623c7$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $d6107acbb7de4bd3$export$35059013cd4a06db)(getModule)
    ];
}
 //# sourceMappingURL=stacktrace.js.map
module.exports["createStackParser"] = $784ab2413af623c7$export$a5739666fb2d03d4;
module.exports["stackParserFromStackParserOptions"] = $784ab2413af623c7$export$1d5cf88b347146d4;
module.exports["getFunctionName"] = $784ab2413af623c7$export$aad197c7121a6651;

});

parcelRegister("husV7", function(module, exports) {

var $fvU8j = parcelRequire("fvU8j");


var $7xYxl = parcelRequire("7xYxl");


var $ketRo = parcelRequire("ketRo");

/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $cbbbabf801f389ad$export$19f53698e68b2496() {
    const gbl = (0, $ketRo.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $cbbbabf801f389ad$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $cbbbabf801f389ad$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $cbbbabf801f389ad$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $cbbbabf801f389ad$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $cbbbabf801f389ad$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $cbbbabf801f389ad$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $cbbbabf801f389ad$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $cbbbabf801f389ad$export$d364f2020ab30578(input) {
    const match = input.match($cbbbabf801f389ad$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $cbbbabf801f389ad$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $7xYxl.snipLine)(line, 0));
    frame.context_line = (0, $7xYxl.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $7xYxl.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $cbbbabf801f389ad$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $fvU8j.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $cbbbabf801f389ad$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}
 //# sourceMappingURL=misc.js.map
module.exports["uuid4"] = $cbbbabf801f389ad$export$19f53698e68b2496;
module.exports["getEventDescription"] = $cbbbabf801f389ad$export$4157119e2b157127;
module.exports["addExceptionTypeValue"] = $cbbbabf801f389ad$export$f26508487bf83ee7;
module.exports["addExceptionMechanism"] = $cbbbabf801f389ad$export$c69a9a0313b03bb1;
module.exports["checkOrSetAlreadyCaught"] = $cbbbabf801f389ad$export$6de4ffac6a2f1098;
module.exports["arrayify"] = $cbbbabf801f389ad$export$3131421a7d01b4fb;

});

parcelRegister("6WvWU", function(module, exports) {

var $jCulH = parcelRequire("jCulH");

/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $50e0f1445cd1aee9$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($50e0f1445cd1aee9$var$States || ($50e0f1445cd1aee9$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $50e0f1445cd1aee9$export$1fda8aa4d135f8aa(value) {
    return new $50e0f1445cd1aee9$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $50e0f1445cd1aee9$export$78e43115b553f358(reason) {
    return new $50e0f1445cd1aee9$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $50e0f1445cd1aee9$export$6f292d4960313241 {
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $50e0f1445cd1aee9$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $50e0f1445cd1aee9$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($50e0f1445cd1aee9$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($50e0f1445cd1aee9$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $50e0f1445cd1aee9$var$States.PENDING) return;
            if ((0, $jCulH.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $50e0f1445cd1aee9$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $50e0f1445cd1aee9$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $50e0f1445cd1aee9$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
    constructor(executor){
        $50e0f1445cd1aee9$export$6f292d4960313241.prototype.__init.call(this);
        $50e0f1445cd1aee9$export$6f292d4960313241.prototype.__init2.call(this);
        $50e0f1445cd1aee9$export$6f292d4960313241.prototype.__init3.call(this);
        $50e0f1445cd1aee9$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $50e0f1445cd1aee9$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
}
 //# sourceMappingURL=syncpromise.js.map
module.exports["resolvedSyncPromise"] = $50e0f1445cd1aee9$export$1fda8aa4d135f8aa;
module.exports["SyncPromise"] = $50e0f1445cd1aee9$export$6f292d4960313241;
module.exports["rejectedSyncPromise"] = $50e0f1445cd1aee9$export$78e43115b553f358;

});

parcelRegister("6Svx4", function(module, exports) {

var $lPueq = parcelRequire("lPueq");

var $fvU8j = parcelRequire("fvU8j");

const $50203ee2fe5c2e79$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $50203ee2fe5c2e79$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $50203ee2fe5c2e79$var$_getIngestEndpoint(dsn) {
    return `${$50203ee2fe5c2e79$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $50203ee2fe5c2e79$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $fvU8j.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $50203ee2fe5c2e79$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $50203ee2fe5c2e79$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$50203ee2fe5c2e79$var$_getIngestEndpoint(dsn)}?${$50203ee2fe5c2e79$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $50203ee2fe5c2e79$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $lPueq.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$50203ee2fe5c2e79$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $lPueq.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
 //# sourceMappingURL=api.js.map
module.exports["getEnvelopeEndpointWithUrlEncodedAuth"] = $50203ee2fe5c2e79$export$9964600bfe84e6a3;
module.exports["getReportDialogEndpoint"] = $50203ee2fe5c2e79$export$671c7ed8e40a7a57;

});

parcelRegister("21cRg", function(module, exports) {

var $ketRo = parcelRequire("ketRo");

var $jCulH = parcelRequire("jCulH");

var $9Yk75 = parcelRequire("9Yk75");

var $aFG2U = parcelRequire("aFG2U");

var $husV7 = parcelRequire("husV7");


var $dr9IQ = parcelRequire("dr9IQ");


var $6y8WD = parcelRequire("6y8WD");


var $duU2C = parcelRequire("duU2C");


var $jCzb2 = parcelRequire("jCzb2");


var $gkXQu = parcelRequire("gkXQu");

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $1785a6180d37e96a$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $duU2C.getCurrentHub)().captureException(exception, (0, $gkXQu.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $1785a6180d37e96a$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $duU2C.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $1785a6180d37e96a$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $duU2C.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $1785a6180d37e96a$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $duU2C.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $1785a6180d37e96a$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $duU2C.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $1785a6180d37e96a$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $duU2C.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $1785a6180d37e96a$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $duU2C.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $1785a6180d37e96a$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $duU2C.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $1785a6180d37e96a$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $duU2C.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $1785a6180d37e96a$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $duU2C.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $1785a6180d37e96a$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $duU2C.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $1785a6180d37e96a$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $duU2C.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $1785a6180d37e96a$export$9a4fed82c350c2bd(callback) {
    return (0, $duU2C.runWithAsyncContext)(()=>{
        return callback((0, $duU2C.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $1785a6180d37e96a$export$e57ac09b143d92a2(span, callback) {
    return $1785a6180d37e96a$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $1785a6180d37e96a$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $duU2C.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $1785a6180d37e96a$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $1785a6180d37e96a$export$c7be4b0125a10cba();
    const client = $1785a6180d37e96a$export$6bb76d6eba7e258c();
    if (!client) (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $husV7.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $1785a6180d37e96a$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $1785a6180d37e96a$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $aFG2U.timestampInSeconds)();
    function finishCheckIn(status) {
        $1785a6180d37e96a$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $aFG2U.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $jCulH.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $1785a6180d37e96a$export$4909b86c8034bf73(timeout) {
    const client = $1785a6180d37e96a$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $1785a6180d37e96a$export$8360e631d277ea4d(timeout) {
    const client = $1785a6180d37e96a$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $1785a6180d37e96a$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $duU2C.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $1785a6180d37e96a$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $duU2C.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $1785a6180d37e96a$export$3f95c6f800b78024() {
    return !!$1785a6180d37e96a$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $1785a6180d37e96a$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $duU2C.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $1785a6180d37e96a$export$c0d84948cecf78d8(context) {
    const client = $1785a6180d37e96a$export$6bb76d6eba7e258c();
    const isolationScope = (0, $duU2C.getIsolationScope)();
    const currentScope = $1785a6180d37e96a$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $dr9IQ.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $ketRo.GLOBAL_OBJ).navigator || {};
    const session = (0, $jCzb2.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $jCzb2.updateSession)(currentSession, {
        status: 'exited'
    });
    $1785a6180d37e96a$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $1785a6180d37e96a$export$17a5be43989a0bc1() {
    const isolationScope = (0, $duU2C.getIsolationScope)();
    const currentScope = $1785a6180d37e96a$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $jCzb2.closeSession)(session);
    $1785a6180d37e96a$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $1785a6180d37e96a$var$_sendSessionUpdate() {
    const isolationScope = (0, $duU2C.getIsolationScope)();
    const currentScope = $1785a6180d37e96a$export$c7be4b0125a10cba();
    const client = $1785a6180d37e96a$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $1785a6180d37e96a$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $1785a6180d37e96a$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $1785a6180d37e96a$var$_sendSessionUpdate();
}
 //# sourceMappingURL=exports.js.map
module.exports["captureException"] = $1785a6180d37e96a$export$f5282963edea4a68;
module.exports["captureEvent"] = $1785a6180d37e96a$export$1462b974fdcf6ba2;
module.exports["addBreadcrumb"] = $1785a6180d37e96a$export$efda9a273d7a036d;
module.exports["withScope"] = $1785a6180d37e96a$export$ec58d9285c204497;
module.exports["getCurrentScope"] = $1785a6180d37e96a$export$c7be4b0125a10cba;
module.exports["getClient"] = $1785a6180d37e96a$export$6bb76d6eba7e258c;
module.exports["startSession"] = $1785a6180d37e96a$export$c0d84948cecf78d8;
module.exports["captureSession"] = $1785a6180d37e96a$export$667e7b4d445d566b;

});

parcelRegister("duU2C", function(module, exports) {

var $9Yk75 = parcelRequire("9Yk75");

var $aFG2U = parcelRequire("aFG2U");

var $ketRo = parcelRequire("ketRo");

var $jCulH = parcelRequire("jCulH");

var $husV7 = parcelRequire("husV7");


var $dr9IQ = parcelRequire("dr9IQ");


var $6y8WD = parcelRequire("6y8WD");


var $kzeX8 = parcelRequire("kzeX8");


var $jCzb2 = parcelRequire("jCzb2");


var $9r9CU = parcelRequire("9r9CU");

/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9d398c59583c8570$export$24a86ef7798177e4 = parseFloat((0, $9r9CU.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9d398c59583c8570$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $9d398c59583c8570$export$8c41bb232f1008b1 {
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $jCulH.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $husV7.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $husV7.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $husV7.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9d398c59583c8570$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $aFG2U.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $9Yk75.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $9d398c59583c8570$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $9d398c59583c8570$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $6y8WD.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $9Yk75.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $9Yk75.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $jCzb2.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $dr9IQ.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $ketRo.GLOBAL_OBJ).navigator || {};
        const session = (0, $jCzb2.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $jCzb2.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9d398c59583c8570$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $9d398c59583c8570$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $kzeX8.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $kzeX8.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9d398c59583c8570$export$19eade501500c6c1() {
    (0, $ketRo.GLOBAL_OBJ).__SENTRY__ = (0, $ketRo.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $ketRo.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $9d398c59583c8570$export$4188a14ad302d1bc(hub) {
    const registry = $9d398c59583c8570$export$19eade501500c6c1();
    const oldHub = $9d398c59583c8570$export$bfa8a924a84a76b7(registry);
    $9d398c59583c8570$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $9d398c59583c8570$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9d398c59583c8570$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9d398c59583c8570$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $9d398c59583c8570$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $9d398c59583c8570$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $9d398c59583c8570$var$getGlobalHub(registry = $9d398c59583c8570$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9d398c59583c8570$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $9d398c59583c8570$export$bfa8a924a84a76b7(registry).isOlderThan($9d398c59583c8570$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $9d398c59583c8570$export$849f05434e95d2f2(registry, new $9d398c59583c8570$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9d398c59583c8570$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $9d398c59583c8570$export$236689a79f5aa020(carrier, parent = $9d398c59583c8570$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9d398c59583c8570$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $9d398c59583c8570$export$bfa8a924a84a76b7(carrier).isOlderThan($9d398c59583c8570$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $9d398c59583c8570$export$849f05434e95d2f2(carrier, new $9d398c59583c8570$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9d398c59583c8570$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9d398c59583c8570$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9d398c59583c8570$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9d398c59583c8570$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9d398c59583c8570$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $9d398c59583c8570$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ketRo.getGlobalSingleton)('hub', ()=>new $9d398c59583c8570$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $9d398c59583c8570$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}
 //# sourceMappingURL=hub.js.map
module.exports["Hub"] = $9d398c59583c8570$export$8c41bb232f1008b1;
module.exports["getCurrentHub"] = $9d398c59583c8570$export$a07cdf6544bbd7c;
module.exports["getIsolationScope"] = $9d398c59583c8570$export$68f3af03034c9e90;
module.exports["runWithAsyncContext"] = $9d398c59583c8570$export$70d775fb1f267027;

});

parcelRegister("fWjB8", function(module, exports) {

var $husV7 = parcelRequire("husV7");

var $9Yk75 = parcelRequire("9Yk75");


var $6y8WD = parcelRequire("6y8WD");


var $blLsF = parcelRequire("blLsF");


var $21cRg = parcelRequire("21cRg");


var $duU2C = parcelRequire("duU2C");

const $b9ab798b65cecd3d$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $b9ab798b65cecd3d$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $b9ab798b65cecd3d$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $husV7.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $b9ab798b65cecd3d$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $b9ab798b65cecd3d$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $b9ab798b65cecd3d$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $b9ab798b65cecd3d$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $b9ab798b65cecd3d$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $b9ab798b65cecd3d$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($b9ab798b65cecd3d$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $blLsF.addGlobalEventProcessor), (0, $duU2C.getCurrentHub));
        $b9ab798b65cecd3d$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $b9ab798b65cecd3d$export$2d8f5188773bcddd(integration) {
    const client = (0, $21cRg.getClient)();
    if (!client || !client.addIntegration) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $b9ab798b65cecd3d$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $b9ab798b65cecd3d$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $b9ab798b65cecd3d$export$2323046b9414659f(fn) {
    return fn;
}
 //# sourceMappingURL=integration.js.map
module.exports["getIntegrationsToSetup"] = $b9ab798b65cecd3d$export$68bc4c01ab8ae766;
module.exports["setupIntegrations"] = $b9ab798b65cecd3d$export$51abed9797baa598;
module.exports["setupIntegration"] = $b9ab798b65cecd3d$export$e7390a03b70a6f2f;
module.exports["afterSetupIntegrations"] = $b9ab798b65cecd3d$export$35abcfd71227c6ca;
module.exports["convertIntegrationFnToClass"] = $b9ab798b65cecd3d$export$afa219bf23651160;
module.exports["defineIntegration"] = $b9ab798b65cecd3d$export$2323046b9414659f;

});

parcelRegister("1A5z7", function(module, exports) {

var $9OC7c = parcelRequire("9OC7c");


var $aFG2U = parcelRequire("aFG2U");

/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $126d7866643ac6a6$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $aFG2U.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $9OC7c.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
 //# sourceMappingURL=clientreport.js.map
module.exports["createClientReportEnvelope"] = $126d7866643ac6a6$export$f3b9ed77c03eeb00;

});

parcelRegister("7rKTM", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $56bf6f252a72c775$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $56bf6f252a72c775$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}
 //# sourceMappingURL=env.js.map
module.exports["getSDKSource"] = $56bf6f252a72c775$export$8ad33f488b1ab046;

});

parcelRegister("lzqTp", function(module, exports) {

var $fvU8j = parcelRequire("fvU8j");


var $21cRg = parcelRequire("21cRg");


var $fWjB8 = parcelRequire("fWjB8");

let $fb41ba2e5219811f$var$originalFunctionToString;
const $fb41ba2e5219811f$var$INTEGRATION_NAME = 'FunctionToString';
const $fb41ba2e5219811f$var$SETUP_CLIENTS = new WeakMap();
const $fb41ba2e5219811f$var$_functionToStringIntegration = ()=>{
    return {
        name: $fb41ba2e5219811f$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $fb41ba2e5219811f$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $fvU8j.getOriginalFunction)(this);
                    const context = $fb41ba2e5219811f$var$SETUP_CLIENTS.has((0, $21cRg.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $fb41ba2e5219811f$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $fb41ba2e5219811f$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $fb41ba2e5219811f$export$7918117e9202e4fb = (0, $fWjB8.defineIntegration)($fb41ba2e5219811f$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $fb41ba2e5219811f$export$da4704525c20ae79 = (0, $fWjB8.convertIntegrationFnToClass)($fb41ba2e5219811f$var$INTEGRATION_NAME, $fb41ba2e5219811f$export$7918117e9202e4fb);
 //# sourceMappingURL=functiontostring.js.map
module.exports["functionToStringIntegration"] = $fb41ba2e5219811f$export$7918117e9202e4fb;
module.exports["FunctionToString"] = $fb41ba2e5219811f$export$da4704525c20ae79;

});

parcelRegister("8e57t", function(module, exports) {

var $husV7 = parcelRequire("husV7");

var $9Yk75 = parcelRequire("9Yk75");

var $7xYxl = parcelRequire("7xYxl");


var $6y8WD = parcelRequire("6y8WD");


var $fWjB8 = parcelRequire("fWjB8");

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $5fd39a27cc332f40$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $5fd39a27cc332f40$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $5fd39a27cc332f40$var$INTEGRATION_NAME = 'InboundFilters';
const $5fd39a27cc332f40$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $5fd39a27cc332f40$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $5fd39a27cc332f40$var$_mergeOptions(options, clientOptions);
            return $5fd39a27cc332f40$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $5fd39a27cc332f40$export$cb3c5c2ceb9818ba = (0, $fWjB8.defineIntegration)($5fd39a27cc332f40$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5fd39a27cc332f40$export$2ffbb5359dcc6be4 = (0, $fWjB8.convertIntegrationFnToClass)($5fd39a27cc332f40$var$INTEGRATION_NAME, $5fd39a27cc332f40$export$cb3c5c2ceb9818ba);
function $5fd39a27cc332f40$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $5fd39a27cc332f40$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $5fd39a27cc332f40$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $5fd39a27cc332f40$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $5fd39a27cc332f40$var$_isSentryError(event)) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $husV7.getEventDescription)(event)}`);
        return true;
    }
    if ($5fd39a27cc332f40$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $husV7.getEventDescription)(event)}`);
        return true;
    }
    if ($5fd39a27cc332f40$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $husV7.getEventDescription)(event)}`);
        return true;
    }
    if ($5fd39a27cc332f40$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $husV7.getEventDescription)(event)}.\nUrl: ${$5fd39a27cc332f40$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$5fd39a27cc332f40$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $husV7.getEventDescription)(event)}.\nUrl: ${$5fd39a27cc332f40$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $5fd39a27cc332f40$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $5fd39a27cc332f40$var$_getPossibleEventMessages(event).some((message)=>(0, $7xYxl.stringMatchesSomePattern)(message, ignoreErrors));
}
function $5fd39a27cc332f40$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $7xYxl.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $5fd39a27cc332f40$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $5fd39a27cc332f40$var$_getEventFilterUrl(event);
    return !url ? false : (0, $7xYxl.stringMatchesSomePattern)(url, denyUrls);
}
function $5fd39a27cc332f40$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $5fd39a27cc332f40$var$_getEventFilterUrl(event);
    return !url ? true : (0, $7xYxl.stringMatchesSomePattern)(url, allowUrls);
}
function $5fd39a27cc332f40$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $6y8WD.DEBUG_BUILD) && possibleMessages.length === 0) (0, $9Yk75.logger).error(`Could not extract message for event ${(0, $husV7.getEventDescription)(event)}`);
    return possibleMessages;
}
function $5fd39a27cc332f40$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $5fd39a27cc332f40$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $5fd39a27cc332f40$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $5fd39a27cc332f40$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).error(`Cannot extract url for event ${(0, $husV7.getEventDescription)(event)}`);
        return null;
    }
}
 //# sourceMappingURL=inboundfilters.js.map
module.exports["inboundFiltersIntegration"] = $5fd39a27cc332f40$export$cb3c5c2ceb9818ba;
module.exports["InboundFilters"] = $5fd39a27cc332f40$export$2ffbb5359dcc6be4;

});

parcelRegister("AcsET", function(module, exports) {

var $9Yk75 = parcelRequire("9Yk75");


var $6y8WD = parcelRequire("6y8WD");


var $21cRg = parcelRequire("21cRg");


var $duU2C = parcelRequire("duU2C");

/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $06cd07731b3c2529$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $6y8WD.DEBUG_BUILD) (0, $9Yk75.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $9Yk75.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $21cRg.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $06cd07731b3c2529$export$ecb76f41d43c0e43(client);
    $06cd07731b3c2529$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $06cd07731b3c2529$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $duU2C.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $06cd07731b3c2529$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}
 //# sourceMappingURL=sdk.js.map
module.exports["initAndBind"] = $06cd07731b3c2529$export$5333c3f1c58d9bc1;

});

parcelRegister("jYHGu", function(module, exports) {

var $fvU8j = parcelRequire("fvU8j");




var $ketRo = parcelRequire("ketRo");




// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $88c4a4baa48051d7$var$WINDOW = (0, $ketRo.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $88c4a4baa48051d7$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $88c4a4baa48051d7$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $88c4a4baa48051d7$var$WINDOW && !!$88c4a4baa48051d7$var$WINDOW.history.pushState && !!$88c4a4baa48051d7$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
 //# sourceMappingURL=supportsHistory.js.map



var $04WQj = parcelRequire("04WQj");

const $e8b581b04c65e6e5$var$WINDOW = (0, $ketRo.GLOBAL_OBJ);
let $e8b581b04c65e6e5$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e8b581b04c65e6e5$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $04WQj.addHandler)(type, handler);
    (0, $04WQj.maybeInstrument)(type, $e8b581b04c65e6e5$var$instrumentHistory);
}
function $e8b581b04c65e6e5$var$instrumentHistory() {
    if (!(0, $88c4a4baa48051d7$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $e8b581b04c65e6e5$var$WINDOW.onpopstate;
    $e8b581b04c65e6e5$var$WINDOW.onpopstate = function(...args) {
        const to = $e8b581b04c65e6e5$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $e8b581b04c65e6e5$var$lastHref;
        $e8b581b04c65e6e5$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $04WQj.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $e8b581b04c65e6e5$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $e8b581b04c65e6e5$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $04WQj.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $fvU8j.fill)($e8b581b04c65e6e5$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $fvU8j.fill)($e8b581b04c65e6e5$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}
 //# sourceMappingURL=history.js.map
module.exports["addHistoryInstrumentationHandler"] = $e8b581b04c65e6e5$export$3f18c56c58114e75;

});

parcelRegister("k6sEr", function(module, exports) {

var $iG9R2 = parcelRequire("iG9R2");


var $9Yk75 = parcelRequire("9Yk75");


var $ketRo = parcelRequire("ketRo");

// eslint-disable-next-line deprecation/deprecation
const $ea2a97c1ba6dd9a4$var$WINDOW = (0, $ketRo.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $ea2a97c1ba6dd9a4$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $ea2a97c1ba6dd9a4$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $ea2a97c1ba6dd9a4$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $ea2a97c1ba6dd9a4$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $ea2a97c1ba6dd9a4$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $ea2a97c1ba6dd9a4$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $ea2a97c1ba6dd9a4$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$ea2a97c1ba6dd9a4$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($ea2a97c1ba6dd9a4$export$18cf36ed71d733e7($ea2a97c1ba6dd9a4$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $ea2a97c1ba6dd9a4$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $ea2a97c1ba6dd9a4$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $iG9R2.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $ea2a97c1ba6dd9a4$export$531055a6c684a70a() {
    return 'ReportingObserver' in $ea2a97c1ba6dd9a4$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $ea2a97c1ba6dd9a4$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$ea2a97c1ba6dd9a4$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
 //# sourceMappingURL=supports.js.map
module.exports["supportsFetch"] = $ea2a97c1ba6dd9a4$export$edf3cb81fd7d2a3e;
module.exports["isNativeFetch"] = $ea2a97c1ba6dd9a4$export$18cf36ed71d733e7;
module.exports["supportsNativeFetch"] = $ea2a97c1ba6dd9a4$export$c82d238e23c40b21;

});

parcelRegister("dRWPa", function(module, exports) {

var $husV7 = parcelRequire("husV7");


var $fvU8j = parcelRequire("fvU8j");


var $ketRo = parcelRequire("ketRo");


var $04WQj = parcelRequire("04WQj");

const $a18ddadee87830a3$var$WINDOW = (0, $ketRo.GLOBAL_OBJ);
const $a18ddadee87830a3$var$DEBOUNCE_DURATION = 1000;
let $a18ddadee87830a3$var$debounceTimerID;
let $a18ddadee87830a3$var$lastCapturedEventType;
let $a18ddadee87830a3$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a18ddadee87830a3$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $04WQj.addHandler)(type, handler);
    (0, $04WQj.maybeInstrument)(type, $a18ddadee87830a3$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $a18ddadee87830a3$export$3014bbf0af0e1d4a() {
    if (!$a18ddadee87830a3$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $04WQj.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $a18ddadee87830a3$var$makeDOMEventHandler(triggerDOMHandler, true);
    $a18ddadee87830a3$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $a18ddadee87830a3$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $a18ddadee87830a3$var$WINDOW[target] && $a18ddadee87830a3$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $fvU8j.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $a18ddadee87830a3$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $fvU8j.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $a18ddadee87830a3$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $a18ddadee87830a3$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $a18ddadee87830a3$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $a18ddadee87830a3$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $a18ddadee87830a3$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $a18ddadee87830a3$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($a18ddadee87830a3$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $fvU8j.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $fvU8j.addNonEnumerableProperty)(target, '_sentryId', (0, $husV7.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$a18ddadee87830a3$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $a18ddadee87830a3$var$lastCapturedEventType = event.type;
            $a18ddadee87830a3$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($a18ddadee87830a3$var$debounceTimerID);
        $a18ddadee87830a3$var$debounceTimerID = $a18ddadee87830a3$var$WINDOW.setTimeout(()=>{
            $a18ddadee87830a3$var$lastCapturedEventTargetId = undefined;
            $a18ddadee87830a3$var$lastCapturedEventType = undefined;
        }, $a18ddadee87830a3$var$DEBOUNCE_DURATION);
    };
}
function $a18ddadee87830a3$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}
 //# sourceMappingURL=dom.js.map
module.exports["addClickKeypressInstrumentationHandler"] = $a18ddadee87830a3$export$5aeffd3db2cf9df7;

});

parcelRegister("erpJl", function(module, exports) {

var $9Yk75 = parcelRequire("9Yk75");


var $fvU8j = parcelRequire("fvU8j");


var $ketRo = parcelRequire("ketRo");


var $04WQj = parcelRequire("04WQj");

/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a8378bd2baa23076$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $04WQj.addHandler)(type, handler);
    (0, $04WQj.maybeInstrument)(type, $a8378bd2baa23076$var$instrumentConsole);
}
function $a8378bd2baa23076$var$instrumentConsole() {
    if (!('console' in (0, $ketRo.GLOBAL_OBJ))) return;
    (0, $9Yk75.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $ketRo.GLOBAL_OBJ).console)) return;
        (0, $fvU8j.fill)((0, $ketRo.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $9Yk75.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $04WQj.triggerHandlers)('console', handlerData);
                const log = (0, $9Yk75.originalConsoleMethods)[level];
                log && log.apply((0, $ketRo.GLOBAL_OBJ).console, args);
            };
        });
    });
}
 //# sourceMappingURL=console.js.map
module.exports["addConsoleInstrumentationHandler"] = $a8378bd2baa23076$export$1d6e0d073f9e6723;

});

parcelRegister("cLOuA", function(module, exports) {

var $fvU8j = parcelRequire("fvU8j");


var $k6sEr = parcelRequire("k6sEr");


var $ketRo = parcelRequire("ketRo");


var $04WQj = parcelRequire("04WQj");

/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $94c10a8bb88a74da$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $04WQj.addHandler)(type, handler);
    (0, $04WQj.maybeInstrument)(type, $94c10a8bb88a74da$var$instrumentFetch);
}
function $94c10a8bb88a74da$var$instrumentFetch() {
    if (!(0, $k6sEr.supportsNativeFetch)()) return;
    (0, $fvU8j.fill)((0, $ketRo.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $94c10a8bb88a74da$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $04WQj.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $ketRo.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $04WQj.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $04WQj.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $94c10a8bb88a74da$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $94c10a8bb88a74da$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($94c10a8bb88a74da$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $94c10a8bb88a74da$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $94c10a8bb88a74da$var$getUrlFromResource(url),
            method: $94c10a8bb88a74da$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $94c10a8bb88a74da$var$getUrlFromResource(arg),
        method: $94c10a8bb88a74da$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
 //# sourceMappingURL=fetch.js.map
module.exports["addFetchInstrumentationHandler"] = $94c10a8bb88a74da$export$f75d3c772c923df0;

});

parcelRegister("1C9Vl", function(module, exports) {

var $jCulH = parcelRequire("jCulH");


var $fvU8j = parcelRequire("fvU8j");


var $ketRo = parcelRequire("ketRo");


var $04WQj = parcelRequire("04WQj");

const $12d109bfcab12074$var$WINDOW = (0, $ketRo.GLOBAL_OBJ);
const $12d109bfcab12074$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $12d109bfcab12074$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $04WQj.addHandler)(type, handler);
    (0, $04WQj.maybeInstrument)(type, $12d109bfcab12074$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $12d109bfcab12074$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$12d109bfcab12074$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $fvU8j.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $jCulH.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $12d109bfcab12074$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$12d109bfcab12074$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$12d109bfcab12074$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $04WQj.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $fvU8j.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $fvU8j.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$12d109bfcab12074$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $jCulH.isString)(header) && (0, $jCulH.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $fvU8j.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$12d109bfcab12074$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $04WQj.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $12d109bfcab12074$var$parseUrl(url) {
    if ((0, $jCulH.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}
 //# sourceMappingURL=xhr.js.map
module.exports["SENTRY_XHR_DATA_KEY"] = $12d109bfcab12074$export$55b6bb1e45c6cf59;
module.exports["addXhrInstrumentationHandler"] = $12d109bfcab12074$export$26ace48dd54c9aea;

});

parcelRegister("4e32G", function(module, exports) {
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $313ad45d1b69c67f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $313ad45d1b69c67f$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $313ad45d1b69c67f$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $313ad45d1b69c67f$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
 //# sourceMappingURL=url.js.map
module.exports["parseUrl"] = $313ad45d1b69c67f$export$7a5253c0f62e0150;

});

parcelRegister("hVeUz", function(module, exports) {
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $d0c3539ecc088a19$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $d0c3539ecc088a19$export$e01cef29b4327697(level) {
    return $d0c3539ecc088a19$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $d0c3539ecc088a19$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $d0c3539ecc088a19$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}
 //# sourceMappingURL=severity.js.map
module.exports["severityLevelFromString"] = $d0c3539ecc088a19$export$d771ef054122c30a;

});

parcelRegister("iUgAG", function(module, exports) {

var $ketRo = parcelRequire("ketRo");


var $04WQj = parcelRequire("04WQj");

let $dc3a53859a156cce$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $dc3a53859a156cce$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $04WQj.addHandler)(type, handler);
    (0, $04WQj.maybeInstrument)(type, $dc3a53859a156cce$var$instrumentError);
}
function $dc3a53859a156cce$var$instrumentError() {
    $dc3a53859a156cce$var$_oldOnErrorHandler = (0, $ketRo.GLOBAL_OBJ).onerror;
    (0, $ketRo.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $04WQj.triggerHandlers)('error', handlerData);
        if ($dc3a53859a156cce$var$_oldOnErrorHandler && !$dc3a53859a156cce$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $dc3a53859a156cce$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $ketRo.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}
 //# sourceMappingURL=globalError.js.map
module.exports["addGlobalErrorInstrumentationHandler"] = $dc3a53859a156cce$export$55b5c3ba2194f0c6;

});

parcelRegister("4ybu6", function(module, exports) {

var $ketRo = parcelRequire("ketRo");


var $04WQj = parcelRequire("04WQj");

let $35033efd00b07085$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $35033efd00b07085$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $04WQj.addHandler)(type, handler);
    (0, $04WQj.maybeInstrument)(type, $35033efd00b07085$var$instrumentUnhandledRejection);
}
function $35033efd00b07085$var$instrumentUnhandledRejection() {
    $35033efd00b07085$var$_oldOnUnhandledRejectionHandler = (0, $ketRo.GLOBAL_OBJ).onunhandledrejection;
    (0, $ketRo.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $04WQj.triggerHandlers)('unhandledrejection', handlerData);
        if ($35033efd00b07085$var$_oldOnUnhandledRejectionHandler && !$35033efd00b07085$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $35033efd00b07085$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $ketRo.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
 //# sourceMappingURL=globalUnhandledRejection.js.map
module.exports["addGlobalUnhandledRejectionInstrumentationHandler"] = $35033efd00b07085$export$8bf4fc6858821a4e;

});

parcelRegister("22PUP", function(module, exports) {

var $jCulH = parcelRequire("jCulH");


var $7xYxl = parcelRequire("7xYxl");

/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $17d40a0e21f964ec$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $jCulH.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $17d40a0e21f964ec$var$truncateAggregateExceptions($17d40a0e21f964ec$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $17d40a0e21f964ec$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $jCulH.isInstanceOf)(error[key], Error)) {
        $17d40a0e21f964ec$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $17d40a0e21f964ec$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $17d40a0e21f964ec$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $jCulH.isInstanceOf)(childError, Error)) {
            $17d40a0e21f964ec$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $17d40a0e21f964ec$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $17d40a0e21f964ec$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $17d40a0e21f964ec$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $17d40a0e21f964ec$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $17d40a0e21f964ec$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $7xYxl.truncate)(exception.value, maxValueLength);
        return exception;
    });
}
 //# sourceMappingURL=aggregate-errors.js.map
module.exports["applyAggregateErrorsToEvent"] = $17d40a0e21f964ec$export$b91c38ed7d8ae9b2;

});

parcelRegister("lOoQm", function(module, exports) {

var $9OC7c = parcelRequire("9OC7c");
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $d097b8a883e1cb49$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $d097b8a883e1cb49$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $d097b8a883e1cb49$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $d097b8a883e1cb49$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $d097b8a883e1cb49$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $d097b8a883e1cb49$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $d097b8a883e1cb49$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $d097b8a883e1cb49$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
 //# sourceMappingURL=ratelimit.js.map


var $9Yk75 = parcelRequire("9Yk75");

var $clOWD = parcelRequire("clOWD");


var $6WvWU = parcelRequire("6WvWU");

/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $11de5d4a1224e534$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $6WvWU.rejectedSyncPromise)(new (0, $clOWD.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $6WvWU.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $6WvWU.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}
 //# sourceMappingURL=promisebuffer.js.map







var $6y8WD = parcelRequire("6y8WD");

const $fe1189e7ffb59d76$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $fe1189e7ffb59d76$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $11de5d4a1224e534$export$85a4f67f852183e6)(options.bufferSize || $fe1189e7ffb59d76$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $9OC7c.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $9OC7c.envelopeItemTypeToDataCategory)(type);
            if ((0, $d097b8a883e1cb49$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $fe1189e7ffb59d76$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $6WvWU.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $9OC7c.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $9OC7c.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $fe1189e7ffb59d76$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $9OC7c.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $9OC7c.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $d097b8a883e1cb49$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $clOWD.SentryError)) {
                (0, $6y8WD.DEBUG_BUILD) && (0, $9Yk75.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $6WvWU.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $fe1189e7ffb59d76$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}
 //# sourceMappingURL=base.js.map
module.exports["createTransport"] = $fe1189e7ffb59d76$export$d09f50d9ab7f7b69;

});

parcelRegister("5D2Vi", function(module, exports) {
/**
 * ------------------------------------------------------------------
 * BFF Error Classes
 * Shared error handling for BFF operations / observability
 * ------------------------------------------------------------------
 */ var $92a98ed8f4fcef12$export$7d83cc20f4070394 = /*#__PURE__*/ function(BFFErrorEnum) {
    BFFErrorEnum["BFF_ERROR"] = "BFF_ERROR";
    BFFErrorEnum["BFF_NETWORK_ERROR"] = "BFF_NETWORK_ERROR";
    return BFFErrorEnum;
}({});
class $92a98ed8f4fcef12$export$c6a4f8515f74c5c8 extends Error {
    constructor(message, context){
        super(message);
        this.context = void 0;
        this.originalError = void 0;
        this.status = void 0;
        this.timestamp = void 0;
        this.name = "BFF_ERROR";
        this.context = context.additionalContext;
        this.originalError = context.originalError;
        this.status = context.status;
        this.timestamp = new Date().toISOString();
    }
}
class $92a98ed8f4fcef12$export$f4de77e3e154579c extends $92a98ed8f4fcef12$export$c6a4f8515f74c5c8 {
    constructor(message, context){
        super(message, context);
        this.url = void 0;
        this.name = "BFF_NETWORK_ERROR";
        this.url = context.url;
    }
}
module.exports["BFFError"] = $92a98ed8f4fcef12$export$c6a4f8515f74c5c8;
module.exports["BFFNetworkError"] = $92a98ed8f4fcef12$export$f4de77e3e154579c;

});

parcelRegister("fAint", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

const $acdb86397111dde9$export$fe188b07687f765a = {
    goalCreate: {
        experienceId: 'uc-goal-create',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Experience,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    teamCreate: {
        experienceId: 'uc-team-create',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Experience,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    projectCreate: {
        experienceId: 'uc-project-create',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Experience,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    universalCreateComponentLoad: {
        experienceId: 'uc-component-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    universalCreatePrefetch: {
        experienceId: 'uc-backend-prefetch',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Operation,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom
        },
        instanceId: undefined
    },
    globalSideNavigationLoad: {
        experienceId: 'global-side-navigation-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    customizationModalLoad: {
        experienceId: 'customization-modal-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    customizationModalUpdate: {
        experienceId: 'customization-modal-update',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Experience,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    globalMoreMenuLoad: {
        experienceId: 'global-more-menu-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    }
};
module.exports["NavigationExperienceId"] = $acdb86397111dde9$export$fe188b07687f765a;

});

parcelRegister("9Kv4c", function(module, exports) {

var $3ePvn = parcelRequire("3ePvn");


var $2nIbk = parcelRequire("2nIbk");

const $3cf0d34a1b146416$var$packageName = "platform-pkg";
const $3cf0d34a1b146416$var$packageVersion = "0.0.0-use.local";
const $3cf0d34a1b146416$var$_default_1 = {
    packageName: $3cf0d34a1b146416$var$packageName,
    packageVersion: $3cf0d34a1b146416$var$packageVersion
};
var $3cf0d34a1b146416$export$2e2bcd8739ae039 = $3cf0d34a1b146416$var$_default_1;


function $56ada1dce007a49c$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $56ada1dce007a49c$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $3cf0d34a1b146416$export$2e2bcd8739ae039).packageVersion,
                ...init?.headers
            }
        });
        // Defensive: misbehaving SWs / fetch wrappers can violate the Promise<Response>
        // contract and resolve to undefined
        if (!response) throw new Error('Failed to fetch data: fetch() returned no response');
        // Validate response status and throw an error for non-OK responses, except for specific cases handled by feature flags.
        if (!response.ok) {
            const isAvailableProductsEndpoint = URL.parse(url)?.pathname.includes((0, $2nIbk.BFFEndpointsEnum).AVAILABLE_PRODUCTS);
            // The Available Products endpoint returns a 403 status code exclusively from blockBotsMiddleware.
            if (response.status === 403 && isAvailableProductsEndpoint) // Return an empty list of sites to prevent pollinator from treating this as a failed request.
            return {
                status: (0, $3ePvn.RequestStatus).COMPLETE,
                data: {
                    sites: []
                }
            };
            throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
        }
        const jsonResponse = await response.json();
        return {
            status: (0, $3ePvn.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $3ePvn.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}
module.exports["fetchJSON"] = $56ada1dce007a49c$export$81bec6e38e8b706b;

});

parcelRegister("2nIbk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ePvn = parcelRequire("3ePvn");


var $8PNRl = parcelRequire("8PNRl");











var $iBJls = parcelRequire("iBJls");

const $770513d6a7f8dace$export$33062d550933de6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useConsumer() {
    const $ = (0, $bDgLe.c)(2);
    const { value: t0 } = (0, $cozmU.useContext)((0, $iBJls.BFFContext));
    const { consumer: consumer } = t0;
    let t1;
    if ($[0] !== consumer) {
        t1 = {
            consumer: consumer
        };
        $[0] = consumer;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function useConsumer() {
    const { value: { consumer: consumer } } = (0, $cozmU.useContext)((0, $iBJls.BFFContext));
    return {
        consumer: consumer
    };
};














const $2a49ddf9f8433f3e$var$BFFOriginUrlContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2a49ddf9f8433f3e$export$405f92d0950d3d4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, url: url } = t0;
    let t1;
    if ($[0] !== children || $[1] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a49ddf9f8433f3e$var$BFFOriginUrlContext.Provider, {
            value: url
        }, children);
        $[0] = children;
        $[1] = url;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, url: url })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a49ddf9f8433f3e$var$BFFOriginUrlContext.Provider, {
        value: url
    }, children);
};
const $2a49ddf9f8433f3e$export$13a55721f6e3a9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($2a49ddf9f8433f3e$var$BFFOriginUrlContext);
} : ()=>{
    return (0, $cozmU.useContext)($2a49ddf9f8433f3e$var$BFFOriginUrlContext);
};


/**
 * Hook that returns the context of a forced origin url (used for supporting global shortcuts locally)
 */ const $bd19be02021d47a6$var$useOriginUrl = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $2a49ddf9f8433f3e$export$13a55721f6e3a9e)();
    return context;
} : ()=>{
    const context = (0, $2a49ddf9f8433f3e$export$13a55721f6e3a9e)();
    return context;
};
var $bd19be02021d47a6$export$2e2bcd8739ae039 = $bd19be02021d47a6$var$useOriginUrl;


var $ac590e61a6089da5$export$92af951f33a9009c = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["MENU_ITEMS_V2"] = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
    return BFFEndpointsEnum;
}({});
const $ac590e61a6089da5$var$getOriginUrl = ({ originUrl: originUrl } = {})=>originUrl || new URL(window.location.href).origin;
const $ac590e61a6089da5$export$3748aab334e7d372 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useURLBuilder(t0) {
    const $ = (0, $bDgLe.c)(20);
    const { cloudId: cloudId, userId: userId, product: product } = t0;
    const { consumer: consumer } = (0, $770513d6a7f8dace$export$33062d550933de6f)();
    const { items: cachedItems } = (0, $8PNRl.useCache)();
    const originUrl = (0, $bd19be02021d47a6$export$2e2bcd8739ae039)();
    let t1;
    if ($[0] !== cloudId || $[1] !== consumer || $[2] !== originUrl || $[3] !== product || $[4] !== userId) {
        t1 = (props)=>{
            const { product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap } = props;
            const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
            let url;
            try {
                url = new URL(`${$ac590e61a6089da5$var$getOriginUrl({
                    originUrl: originUrl
                })}${baseUrl}`);
            } catch (t2) {
                return "";
            }
            const searchParams = new URLSearchParams();
            const queryParams = [
                [
                    "tenantid",
                    cloudId
                ],
                [
                    "product",
                    productParam || product
                ],
                [
                    "orgid",
                    orgId
                ],
                [
                    "userid",
                    userIdParam || userId
                ],
                [
                    "source",
                    consumer
                ],
                [
                    "locale",
                    locale
                ],
                [
                    "subproduct",
                    subProduct
                ],
                [
                    "d",
                    d
                ],
                [
                    "ro",
                    ro
                ],
                [
                    "rt",
                    rt
                ],
                [
                    "ap",
                    ap
                ]
            ];
            queryParams.forEach((t3)=>{
                const [key, value] = t3;
                if (value) searchParams.append(key, value);
            });
            url.search = searchParams.toString();
            return url.toString();
        };
        $[0] = cloudId;
        $[1] = consumer;
        $[2] = originUrl;
        $[3] = product;
        $[4] = userId;
        $[5] = t1;
    } else t1 = $[5];
    const buildUCMenuItemsURL = t1;
    let t2;
    if ($[6] !== cachedItems || $[7] !== originUrl) {
        t2 = (t3)=>{
            const { baseUrl: baseUrl_0 } = t3;
            const finalBaseUrl = baseUrl_0 ?? "/gateway/api/app-switcher/api/available-products";
            if (cachedItems.length > 0) return "";
            return `${$ac590e61a6089da5$var$getOriginUrl({
                originUrl: originUrl
            })}${finalBaseUrl}?${""}`;
        };
        $[6] = cachedItems;
        $[7] = originUrl;
        $[8] = t2;
    } else t2 = $[8];
    const buildProductShortcutURL = t2;
    let t3;
    if ($[9] !== buildProductShortcutURL || $[10] !== cloudId || $[11] !== consumer || $[12] !== originUrl || $[13] !== product || $[14] !== userId) {
        t3 = (t4)=>{
            const { baseUrl: baseUrl_1 } = t4;
            let url_0 = "";
            if (baseUrl_1) url_0 = `${$ac590e61a6089da5$var$getOriginUrl({
                originUrl: originUrl
            })}${baseUrl_1}`;
            bb39: switch(consumer){
                case (0, $3ePvn.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                    url_0 = buildProductShortcutURL({});
                    break bb39;
                case (0, $3ePvn.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                    url_0 = buildProductShortcutURL({});
            }
            if (!url_0) return url_0;
            let formattedUrl;
            try {
                formattedUrl = new URL(url_0);
            } catch (t5) {
                return url_0;
            }
            const updatedParams = new URLSearchParams(formattedUrl.search);
            if (consumer) updatedParams.append("source", consumer);
            if (cloudId) updatedParams.append("tenantid", cloudId);
            if (userId) updatedParams.append("userid", userId);
            if (product) updatedParams.append("product", product);
            return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
        };
        $[9] = buildProductShortcutURL;
        $[10] = cloudId;
        $[11] = consumer;
        $[12] = originUrl;
        $[13] = product;
        $[14] = userId;
        $[15] = t3;
    } else t3 = $[15];
    const buildURL = t3;
    let t4;
    if ($[16] !== buildProductShortcutURL || $[17] !== buildUCMenuItemsURL || $[18] !== buildURL) {
        t4 = {
            buildURL: buildURL,
            buildProductShortcutURL: buildProductShortcutURL,
            buildUCMenuItemsURL: buildUCMenuItemsURL
        };
        $[16] = buildProductShortcutURL;
        $[17] = buildUCMenuItemsURL;
        $[18] = buildURL;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : function useURLBuilder({ cloudId: cloudId, userId: userId, product: product }) {
    const { consumer: consumer } = (0, $770513d6a7f8dace$export$33062d550933de6f)();
    const { items: cachedItems } = (0, $8PNRl.useCache)();
    const originUrl = (0, $bd19be02021d47a6$export$2e2bcd8739ae039)();
    const buildUCMenuItemsURL = (0, $cozmU.useCallback)((props)=>{
        const { product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap } = props;
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
        let url;
        try {
            url = new URL(`${$ac590e61a6089da5$var$getOriginUrl({
                originUrl: originUrl
            })}${baseUrl}`);
        } catch (e) {
            return '';
        }
        const searchParams = new URLSearchParams();
        // Maintain specific order: tenantid, product, orgid, userid, source, then other params
        const queryParams = [
            [
                'tenantid',
                cloudId
            ],
            [
                'product',
                productParam || product
            ],
            [
                'orgid',
                orgId
            ],
            [
                'userid',
                userIdParam || userId
            ],
            [
                'source',
                consumer
            ],
            [
                'locale',
                locale
            ],
            [
                'subproduct',
                subProduct
            ],
            [
                'd',
                d
            ],
            [
                'ro',
                ro
            ],
            [
                'rt',
                rt
            ],
            [
                'ap',
                ap
            ]
        ];
        queryParams.forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        cloudId,
        product,
        userId,
        consumer,
        originUrl
    ]);
    const buildProductShortcutURL = (0, $cozmU.useCallback)(({ baseUrl: baseUrl_0 })=>{
        const finalBaseUrl = baseUrl_0 ?? "/gateway/api/app-switcher/api/available-products";
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (cachedItems.length > 0) return '';
        const queryValues = '';
        return `${$ac590e61a6089da5$var$getOriginUrl({
            originUrl: originUrl
        })}${finalBaseUrl}?${queryValues}`;
    }, [
        cachedItems,
        originUrl
    ]);
    const buildURL = (0, $cozmU.useCallback)(({ baseUrl: baseUrl_1 })=>{
        let url_0 = '';
        if (baseUrl_1) url_0 = `${$ac590e61a6089da5$var$getOriginUrl({
            originUrl: originUrl
        })}${baseUrl_1}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $3ePvn.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url_0 = buildProductShortcutURL({});
                break;
            case (0, $3ePvn.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url_0 = buildProductShortcutURL({});
                break;
        }
        if (!url_0) return url_0;
        // Append the consumer to the URL
        let formattedUrl;
        try {
            formattedUrl = new URL(url_0);
        } catch (e_0) {
            return url_0;
        }
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        if (userId) updatedParams.append('userid', userId);
        if (product) updatedParams.append('product', product);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId,
        userId,
        product,
        originUrl
    ]);
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCMenuItemsURL: buildUCMenuItemsURL
    };
};
module.exports["BFFEndpointsEnum"] = $ac590e61a6089da5$export$92af951f33a9009c;
module.exports["useURLBuilder"] = $ac590e61a6089da5$export$3748aab334e7d372;

});

parcelRegister("8PNRl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iBJls = parcelRequire("iBJls");

const $e6434da8a9e22a2b$export$c6e89b6bb9436bc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCache() {
    const $ = (0, $bDgLe.c)(18);
    const { value: t0, setValue: setValue } = (0, $cozmU.useContext)((0, $iBJls.BFFContext));
    const { consumer: consumer, cache: cache, cacheKey: cacheKey } = t0;
    if (!consumer) throw new Error("BFFContext Consumer is not set");
    let t1;
    if ($[0] !== cache || $[1] !== cacheKey) {
        t1 = cache[cacheKey] ?? [];
        $[0] = cache;
        $[1] = cacheKey;
        $[2] = t1;
    } else t1 = $[2];
    const items = t1;
    let t2;
    if ($[3] !== consumer || $[4] !== setValue) {
        t2 = (updatedCacheKey)=>{
            setValue((prev)=>({
                    ...prev,
                    cacheKey: `${consumer}-${updatedCacheKey}`
                }));
        };
        $[3] = consumer;
        $[4] = setValue;
        $[5] = t2;
    } else t2 = $[5];
    const updateCacheKey = t2;
    let t3;
    if ($[6] !== cacheKey || $[7] !== setValue) {
        t3 = (items_0, t4)=>{
            const compareKey = t4 === undefined ? "cloudId" : t4;
            setValue((prev_0)=>{
                const itemData = prev_0.cache[cacheKey] ?? [];
                for (const item of items_0){
                    const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                    if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                    else itemData.push(item);
                }
                return {
                    ...prev_0,
                    cache: {
                        ...prev_0.cache,
                        [cacheKey]: itemData
                    }
                };
            });
        };
        $[6] = cacheKey;
        $[7] = setValue;
        $[8] = t3;
    } else t3 = $[8];
    const addItemsToCache = t3;
    let t4;
    if ($[9] !== cacheKey || $[10] !== setValue) {
        t4 = ()=>{
            setValue((prev_1)=>({
                    ...prev_1,
                    cache: {
                        ...prev_1.cache,
                        [cacheKey]: []
                    }
                }));
        };
        $[9] = cacheKey;
        $[10] = setValue;
        $[11] = t4;
    } else t4 = $[11];
    const clearCache = t4;
    let t5;
    if ($[12] !== addItemsToCache || $[13] !== cacheKey || $[14] !== clearCache || $[15] !== items || $[16] !== updateCacheKey) {
        t5 = {
            addItemsToCache: addItemsToCache,
            cacheKey: cacheKey,
            clearCache: clearCache,
            items: items,
            updateCacheKey: updateCacheKey
        };
        $[12] = addItemsToCache;
        $[13] = cacheKey;
        $[14] = clearCache;
        $[15] = items;
        $[16] = updateCacheKey;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : function useCache() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $cozmU.useContext)((0, $iBJls.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $cozmU.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $cozmU.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $cozmU.useCallback)((items_0, compareKey = 'cloudId')=>{
        setValue((prev_0)=>{
            const itemData = prev_0.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items_0){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev_0,
                cache: {
                    ...prev_0.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $cozmU.useCallback)(()=>{
        setValue((prev_1)=>({
                ...prev_1,
                cache: {
                    ...prev_1.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        cacheKey: cacheKey,
        clearCache: clearCache,
        items: items,
        updateCacheKey: updateCacheKey
    };
};
module.exports["useCache"] = $e6434da8a9e22a2b$export$c6e89b6bb9436bc0;

});

parcelRegister("hrm0L", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ePvn = parcelRequire("3ePvn");


var $iBJls = parcelRequire("iBJls");

const $49b19f4a84f2889d$export$53cc6abb6942ce72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useStatus() {
    const $ = (0, $bDgLe.c)(20);
    const { setValue: setValue, value: t0, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $iBJls.useBFFContext)();
    const { status: status, error: error } = t0;
    const isInitializing = status === (0, $3ePvn.RequestStatus).INIT;
    const isComplete = status === (0, $3ePvn.RequestStatus).COMPLETE;
    const isError = status === (0, $3ePvn.RequestStatus).ERROR;
    const isLoading = status === (0, $3ePvn.RequestStatus).LOADING;
    const isLoaded = status !== (0, $3ePvn.RequestStatus).LOADING;
    let t1;
    if ($[0] !== currentLoadingRequests.length || $[1] !== setValue || $[2] !== status) {
        t1 = ()=>{
            if (!currentLoadingRequests.length && status === (0, $3ePvn.RequestStatus).LOADING) setValue($49b19f4a84f2889d$var$_temp);
        };
        $[0] = currentLoadingRequests.length;
        $[1] = setValue;
        $[2] = status;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== currentLoadingRequests || $[5] !== setValue || $[6] !== status) {
        t2 = [
            currentLoadingRequests,
            setValue,
            status
        ];
        $[4] = currentLoadingRequests;
        $[5] = setValue;
        $[6] = status;
        $[7] = t2;
    } else t2 = $[7];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[8] !== setValue || $[9] !== updateCurrentLoadingRequests) {
        t3 = (newStatus, integratingComponent, error_0)=>{
            if (newStatus === (0, $3ePvn.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).LOADING);
            if (newStatus === (0, $3ePvn.RequestStatus).COMPLETE) {
                if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).COMPLETE);
            }
            if (newStatus === (0, $3ePvn.RequestStatus).ERROR) {
                if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).ERROR);
            }
            setValue((prev_0)=>{
                const isErrorStatus = newStatus === (0, $3ePvn.RequestStatus).ERROR;
                return {
                    ...prev_0,
                    status: isErrorStatus ? (0, $3ePvn.RequestStatus).ERROR : (0, $3ePvn.RequestStatus).LOADING,
                    error: isErrorStatus ? error_0 : undefined
                };
            });
        };
        $[8] = setValue;
        $[9] = updateCurrentLoadingRequests;
        $[10] = t3;
    } else t3 = $[10];
    const setStatus = t3;
    let t4;
    if ($[11] !== error || $[12] !== isComplete || $[13] !== isError || $[14] !== isInitializing || $[15] !== isLoaded || $[16] !== isLoading || $[17] !== setStatus || $[18] !== status) {
        t4 = {
            error: error,
            isComplete: isComplete,
            isError: isError,
            isInitializing: isInitializing,
            isLoaded: isLoaded,
            isLoading: isLoading,
            setStatus: setStatus,
            status: status
        };
        $[11] = error;
        $[12] = isComplete;
        $[13] = isError;
        $[14] = isInitializing;
        $[15] = isLoaded;
        $[16] = isLoading;
        $[17] = setStatus;
        $[18] = status;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : function useStatus() {
    const { setValue: setValue, value: { status: status, error: error }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $iBJls.useBFFContext)();
    const isInitializing = (0, $cozmU.useMemo)(()=>status === (0, $3ePvn.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $cozmU.useMemo)(()=>status === (0, $3ePvn.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $cozmU.useMemo)(()=>status === (0, $3ePvn.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $cozmU.useMemo)(()=>status === (0, $3ePvn.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $cozmU.useMemo)(()=>status !== (0, $3ePvn.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $cozmU.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $3ePvn.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $3ePvn.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $3ePvn.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $cozmU.useCallback)((newStatus, integratingComponent, error_0)=>{
        if (newStatus === (0, $3ePvn.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).LOADING);
        if (newStatus === (0, $3ePvn.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $3ePvn.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).ERROR);
        }
        setValue((prev_0)=>{
            const isErrorStatus = newStatus === (0, $3ePvn.RequestStatus).ERROR;
            return {
                ...prev_0,
                status: isErrorStatus ? (0, $3ePvn.RequestStatus).ERROR : (0, $3ePvn.RequestStatus).LOADING,
                error: isErrorStatus ? error_0 : undefined
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        error: error,
        isComplete: isComplete,
        isError: isError,
        isInitializing: isInitializing,
        isLoaded: isLoaded,
        isLoading: isLoading,
        setStatus: setStatus,
        status: status
    };
};
function $49b19f4a84f2889d$var$_temp(prev) {
    if (prev.status === (0, $3ePvn.RequestStatus).ERROR) return prev;
    return {
        ...prev,
        status: (0, $3ePvn.RequestStatus).COMPLETE
    };
}
module.exports["useStatus"] = $49b19f4a84f2889d$export$53cc6abb6942ce72;

});

parcelRegister("6y8WD", function(module, exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4c4cdb46267209de$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map
module.exports["DEBUG_BUILD"] = $4c4cdb46267209de$export$16a28057038b10ef;

});

parcelRegister("jCzb2", function(module, exports) {

var $fvU8j = parcelRequire("fvU8j");

var $aFG2U = parcelRequire("aFG2U");

var $husV7 = parcelRequire("husV7");

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $e48cda57662b0b9d$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $aFG2U.timestampInSeconds)();
    const session = {
        sid: (0, $husV7.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e48cda57662b0b9d$var$sessionToJSON(session)
    };
    if (context) $e48cda57662b0b9d$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $e48cda57662b0b9d$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $aFG2U.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $husV7.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $e48cda57662b0b9d$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $e48cda57662b0b9d$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $e48cda57662b0b9d$var$sessionToJSON(session) {
    return (0, $fvU8j.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}
 //# sourceMappingURL=session.js.map
module.exports["makeSession"] = $e48cda57662b0b9d$export$14a186326edbb264;
module.exports["updateSession"] = $e48cda57662b0b9d$export$531818e825e774db;
module.exports["closeSession"] = $e48cda57662b0b9d$export$56521d9ba90f62ee;

});

parcelRegister("lryW8", function(module, exports) {

var $fvU8j = parcelRequire("fvU8j");


var $dr9IQ = parcelRequire("dr9IQ");


var $21cRg = parcelRequire("21cRg");


var $8Rrb9 = parcelRequire("8Rrb9");


var $dPMmU = parcelRequire("dPMmU");

/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $f9c7384db85494d9$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $fvU8j.dropUndefinedKeys)({
        environment: options.environment || (0, $dr9IQ.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $f9c7384db85494d9$export$a117f995597e25df(span) {
    const client = (0, $21cRg.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $f9c7384db85494d9$export$366bad00d6815eed((0, $dPMmU.spanToJSON)(span).trace_id || '', client, (0, $21cRg.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $8Rrb9.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $dPMmU.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $dPMmU.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
 //# sourceMappingURL=dynamicSamplingContext.js.map
module.exports["getDynamicSamplingContextFromClient"] = $f9c7384db85494d9$export$366bad00d6815eed;
module.exports["getDynamicSamplingContextFromSpan"] = $f9c7384db85494d9$export$a117f995597e25df;

});

parcelRegister("aFG2U", function(module, exports) {

var $ketRo = parcelRequire("ketRo");

const $7c4e592d08f6cb99$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $7c4e592d08f6cb99$export$7740643b9eeaf0c4() {
    return Date.now() / $7c4e592d08f6cb99$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $7c4e592d08f6cb99$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $ketRo.GLOBAL_OBJ);
    if (!performance || !performance.now) return $7c4e592d08f6cb99$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $7c4e592d08f6cb99$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $7c4e592d08f6cb99$export$ee52dced521e3e18 = $7c4e592d08f6cb99$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $7c4e592d08f6cb99$export$c5907b5a8838db13 = $7c4e592d08f6cb99$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $7c4e592d08f6cb99$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $7c4e592d08f6cb99$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $ketRo.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $7c4e592d08f6cb99$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $7c4e592d08f6cb99$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $7c4e592d08f6cb99$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $7c4e592d08f6cb99$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();
 //# sourceMappingURL=time.js.map
module.exports["dateTimestampInSeconds"] = $7c4e592d08f6cb99$export$7740643b9eeaf0c4;
module.exports["timestampInSeconds"] = $7c4e592d08f6cb99$export$ee52dced521e3e18;

});

parcelRegister("dr9IQ", function(module, exports) {
const $9c855699fd376035$export$849dbeeeda01ae98 = 'production';
 //# sourceMappingURL=constants.js.map
module.exports["DEFAULT_ENVIRONMENT"] = $9c855699fd376035$export$849dbeeeda01ae98;

});

parcelRegister("blLsF", function(module, exports) {

var $ketRo = parcelRequire("ketRo");

var $jCulH = parcelRequire("jCulH");

var $9Yk75 = parcelRequire("9Yk75");

var $6WvWU = parcelRequire("6WvWU");


var $6y8WD = parcelRequire("6y8WD");

/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $843678b0e8b9d969$export$3c4238858b85e8ac() {
    return (0, $ketRo.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $843678b0e8b9d969$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $843678b0e8b9d969$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $843678b0e8b9d969$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $6WvWU.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $6y8WD.DEBUG_BUILD) && processor.id && result === null && (0, $9Yk75.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $jCulH.isThenable)(result)) result.then((final)=>$843678b0e8b9d969$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $843678b0e8b9d969$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}
 //# sourceMappingURL=eventProcessors.js.map
module.exports["getGlobalEventProcessors"] = $843678b0e8b9d969$export$3c4238858b85e8ac;
module.exports["addGlobalEventProcessor"] = $843678b0e8b9d969$export$8e4e25f54d456511;
module.exports["notifyEventProcessors"] = $843678b0e8b9d969$export$bf2a096c3e883e79;

});

parcelRegister("kzeX8", function(module, exports) {

var $aFG2U = parcelRequire("aFG2U");

var $jCulH = parcelRequire("jCulH");

var $9Yk75 = parcelRequire("9Yk75");

var $husV7 = parcelRequire("husV7");


var $blLsF = parcelRequire("blLsF");


var $jCzb2 = parcelRequire("jCzb2");


var $hwedj = parcelRequire("hwedj");

/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $ef92acde040c8030$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $ef92acde040c8030$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $ef92acde040c8030$export$775b6bb06e53a214 {
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $ef92acde040c8030$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $ef92acde040c8030$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $jCzb2.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $ef92acde040c8030$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $jCulH.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $ef92acde040c8030$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $ef92acde040c8030$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $aFG2U.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $hwedj.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $blLsF.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $blLsF.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $husV7.uuid4)();
        if (!this._client) {
            (0, $9Yk75.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $husV7.uuid4)();
        if (!this._client) {
            (0, $9Yk75.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $husV7.uuid4)();
        if (!this._client) {
            (0, $9Yk75.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $ef92acde040c8030$var$generatePropagationContext();
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $ef92acde040c8030$export$aa55d5ab8e05984f() {
    if (!$ef92acde040c8030$var$globalScope) $ef92acde040c8030$var$globalScope = new $ef92acde040c8030$export$775b6bb06e53a214();
    return $ef92acde040c8030$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $ef92acde040c8030$export$c83048efd17527d6(scope) {
    $ef92acde040c8030$var$globalScope = scope;
}
function $ef92acde040c8030$var$generatePropagationContext() {
    return {
        traceId: (0, $husV7.uuid4)(),
        spanId: (0, $husV7.uuid4)().substring(16)
    };
}
 //# sourceMappingURL=scope.js.map
module.exports["Scope"] = $ef92acde040c8030$export$775b6bb06e53a214;
module.exports["getGlobalScope"] = $ef92acde040c8030$export$aa55d5ab8e05984f;

});

parcelRegister("hwedj", function(module, exports) {

var $husV7 = parcelRequire("husV7");

var $fvU8j = parcelRequire("fvU8j");


var $lryW8 = parcelRequire("lryW8");


var $8Rrb9 = parcelRequire("8Rrb9");


var $dPMmU = parcelRequire("dPMmU");

/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $cc107362a4d4d42e$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $cc107362a4d4d42e$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $cc107362a4d4d42e$var$applySpanToEvent(event, span);
    $cc107362a4d4d42e$var$applyFingerprintToEvent(event, fingerprint);
    $cc107362a4d4d42e$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $cc107362a4d4d42e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $cc107362a4d4d42e$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $cc107362a4d4d42e$export$b1a120a2871faa46(data, 'extra', extra);
    $cc107362a4d4d42e$export$b1a120a2871faa46(data, 'tags', tags);
    $cc107362a4d4d42e$export$b1a120a2871faa46(data, 'user', user);
    $cc107362a4d4d42e$export$b1a120a2871faa46(data, 'contexts', contexts);
    $cc107362a4d4d42e$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $cc107362a4d4d42e$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $cc107362a4d4d42e$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $fvU8j.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $fvU8j.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $fvU8j.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $fvU8j.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $cc107362a4d4d42e$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $cc107362a4d4d42e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $cc107362a4d4d42e$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $dPMmU.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $8Rrb9.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $lryW8.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $dPMmU.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $cc107362a4d4d42e$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $husV7.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}
 //# sourceMappingURL=applyScopeDataToEvent.js.map
module.exports["applyScopeDataToEvent"] = $cc107362a4d4d42e$export$43988bc651a80216;
module.exports["mergeScopeData"] = $cc107362a4d4d42e$export$25ac7e259a513db4;

});

parcelRegister("dPMmU", function(module, exports) {

var $fvU8j = parcelRequire("fvU8j");

var $HZrvg = parcelRequire("HZrvg");

var $aFG2U = parcelRequire("aFG2U");

// These are aligned with OpenTelemetry trace flags
const $a1258ebe0dbc07f2$export$208d5b368507fb8b = 0x0;
const $a1258ebe0dbc07f2$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $a1258ebe0dbc07f2$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $a1258ebe0dbc07f2$export$92d8c23565496537(span);
    return (0, $fvU8j.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $a1258ebe0dbc07f2$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $a1258ebe0dbc07f2$export$5caecac1caaf3a71(span);
    return (0, $HZrvg.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $a1258ebe0dbc07f2$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $a1258ebe0dbc07f2$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $a1258ebe0dbc07f2$var$ensureTimestampInSeconds(input.getTime());
    return (0, $aFG2U.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $a1258ebe0dbc07f2$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $a1258ebe0dbc07f2$export$92d8c23565496537(span) {
    if ($a1258ebe0dbc07f2$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $a1258ebe0dbc07f2$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $a1258ebe0dbc07f2$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $a1258ebe0dbc07f2$export$eb571cd9b5d98de8);
}
 //# sourceMappingURL=spanUtils.js.map
module.exports["spanToTraceContext"] = $a1258ebe0dbc07f2$export$46c6fbd1d265ebf0;
module.exports["spanToJSON"] = $a1258ebe0dbc07f2$export$92d8c23565496537;
module.exports["spanIsSampled"] = $a1258ebe0dbc07f2$export$5caecac1caaf3a71;

});

parcelRegister("iG9R2", function(module, exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $d993cb1a81434a90$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map
module.exports["DEBUG_BUILD"] = $d993cb1a81434a90$export$16a28057038b10ef;

});

parcelRegister("gkXQu", function(module, exports) {

var $husV7 = parcelRequire("husV7");

var $aFG2U = parcelRequire("aFG2U");

var $ketRo = parcelRequire("ketRo");

var $c9zD7 = parcelRequire("c9zD7");

var $7xYxl = parcelRequire("7xYxl");


var $dr9IQ = parcelRequire("dr9IQ");


var $blLsF = parcelRequire("blLsF");


var $kzeX8 = parcelRequire("kzeX8");


var $hwedj = parcelRequire("hwedj");


var $dPMmU = parcelRequire("dPMmU");

/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $be4cefad26e846a9$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $husV7.uuid4)(),
        timestamp: event.timestamp || (0, $aFG2U.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $be4cefad26e846a9$var$applyClientOptions(prepared, options);
    $be4cefad26e846a9$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $be4cefad26e846a9$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $be4cefad26e846a9$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $husV7.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $kzeX8.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $hwedj.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $hwedj.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $hwedj.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $blLsF.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $blLsF.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $be4cefad26e846a9$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $be4cefad26e846a9$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $be4cefad26e846a9$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $dr9IQ.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $7xYxl.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $7xYxl.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $7xYxl.truncate)(request.url, maxValueLength);
}
const $be4cefad26e846a9$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $be4cefad26e846a9$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $ketRo.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $be4cefad26e846a9$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $be4cefad26e846a9$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $be4cefad26e846a9$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $be4cefad26e846a9$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $be4cefad26e846a9$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $c9zD7.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $c9zD7.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $c9zD7.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $c9zD7.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $c9zD7.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $dPMmU.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $c9zD7.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $be4cefad26e846a9$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $kzeX8.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $be4cefad26e846a9$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($be4cefad26e846a9$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($be4cefad26e846a9$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $be4cefad26e846a9$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $kzeX8.Scope) || typeof hint === 'function';
}
const $be4cefad26e846a9$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $be4cefad26e846a9$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$be4cefad26e846a9$var$captureContextKeys.includes(key));
}
 //# sourceMappingURL=prepareEvent.js.map
module.exports["prepareEvent"] = $be4cefad26e846a9$export$2d67fb380bd11267;
module.exports["parseEventHintOrCaptureContext"] = $be4cefad26e846a9$export$76b5f966996d1653;

});

parcelRegister("9r9CU", function(module, exports) {
const $6dee1a55013d71eb$export$31499a9cd224b78c = '7.120.3';
 //# sourceMappingURL=version.js.map
module.exports["SDK_VERSION"] = $6dee1a55013d71eb$export$31499a9cd224b78c;

});

parcelRegister("04WQj", function(module, exports) {

var $iG9R2 = parcelRequire("iG9R2");


var $9Yk75 = parcelRequire("9Yk75");


var $akjeV = parcelRequire("akjeV");

// We keep the handlers globally
const $00ee04cac08a8bb7$var$handlers = {};
const $00ee04cac08a8bb7$var$instrumented = {};
/** Add a handler function. */ function $00ee04cac08a8bb7$export$a4e09611e30da72e(type, handler) {
    $00ee04cac08a8bb7$var$handlers[type] = $00ee04cac08a8bb7$var$handlers[type] || [];
    $00ee04cac08a8bb7$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $00ee04cac08a8bb7$export$b17eab759a1cb5fe() {
    Object.keys($00ee04cac08a8bb7$var$handlers).forEach((key)=>{
        $00ee04cac08a8bb7$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $00ee04cac08a8bb7$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$00ee04cac08a8bb7$var$instrumented[type]) {
        instrumentFn();
        $00ee04cac08a8bb7$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $00ee04cac08a8bb7$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $00ee04cac08a8bb7$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $iG9R2.DEBUG_BUILD) && (0, $9Yk75.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $akjeV.getFunctionName)(handler)}\nError:`, e);
    }
}
 //# sourceMappingURL=_handlers.js.map
module.exports["addHandler"] = $00ee04cac08a8bb7$export$a4e09611e30da72e;
module.exports["maybeInstrument"] = $00ee04cac08a8bb7$export$e18d6c5462c01368;
module.exports["triggerHandlers"] = $00ee04cac08a8bb7$export$b18c893e424d3127;

});

parcelRegister("clOWD", function(module, exports) {
/** An error emitted by Sentry SDKs and related utilities. */ class $8fdef6c5ee2072aa$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}
 //# sourceMappingURL=error.js.map
module.exports["SentryError"] = $8fdef6c5ee2072aa$export$5949942ba2a7c0e2;

});

parcelRegister("8Rrb9", function(module, exports) {
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $01aa3304b2231869$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}
 //# sourceMappingURL=getRootSpan.js.map
module.exports["getRootSpan"] = $01aa3304b2231869$export$c4c6a79b1260ca1b;

});

parcelRegister("HZrvg", function(module, exports) {

var $lgvs2 = parcelRequire("lgvs2");


var $husV7 = parcelRequire("husV7");

// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $0843ad7ccaa9ce55$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $0843ad7ccaa9ce55$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($0843ad7ccaa9ce55$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $0843ad7ccaa9ce55$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $0843ad7ccaa9ce55$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $lgvs2.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $husV7.uuid4)(),
            spanId: (0, $husV7.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $husV7.uuid4)(),
            parentSpanId: parentSpanId || (0, $husV7.uuid4)().substring(16),
            spanId: (0, $husV7.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $0843ad7ccaa9ce55$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $0843ad7ccaa9ce55$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $lgvs2.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $husV7.uuid4)(),
        spanId: (0, $husV7.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $husV7.uuid4)(),
        parentSpanId: parentSpanId || (0, $husV7.uuid4)().substring(16),
        spanId: (0, $husV7.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $0843ad7ccaa9ce55$export$f35d907436da45cf(traceId = (0, $husV7.uuid4)(), spanId = (0, $husV7.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
 //# sourceMappingURL=tracing.js.map
module.exports["generateSentryTraceHeader"] = $0843ad7ccaa9ce55$export$f35d907436da45cf;

});

parcelRegister("lgvs2", function(module, exports) {

var $iG9R2 = parcelRequire("iG9R2");


var $jCulH = parcelRequire("jCulH");


var $9Yk75 = parcelRequire("9Yk75");

const $f7b37d2298126c69$export$9ca9946bd449ac06 = 'baggage';
const $f7b37d2298126c69$export$6e69537d67fa20f = 'sentry-';
const $f7b37d2298126c69$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $f7b37d2298126c69$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $f7b37d2298126c69$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $jCulH.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $f7b37d2298126c69$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $f7b37d2298126c69$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($f7b37d2298126c69$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($f7b37d2298126c69$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $f7b37d2298126c69$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$f7b37d2298126c69$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $f7b37d2298126c69$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $f7b37d2298126c69$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $f7b37d2298126c69$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $f7b37d2298126c69$export$bdd844ddb2def819) {
            (0, $iG9R2.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}
 //# sourceMappingURL=baggage.js.map
module.exports["baggageHeaderToDynamicSamplingContext"] = $f7b37d2298126c69$export$5b96ee2c8421f107;

});


//# sourceMappingURL=ConversationAssistant.6af2fce3.js.map
